import { CustomizationEntry } from "../../Redux/reduxState";
import { Category, SubCategory, UISelectorType } from "../../utilities/types";

const colorAndPaddingEntries: CustomizationEntry[] = [


  {
    id: 'accent',
    displayName: 'Accent',
    category: Category.ColorAndPaddings,
    uiSelectorType: UISelectorType.colorSelector,
  },
  {
    id: 'backgroundColor',
    displayName: 'Background Color',
    category: Category.ColorAndPaddings,
    uiSelectorType: UISelectorType.rgbaSelector,
  },
  {
    id: 'backgroundImage',
    displayName: 'Background Image (Url)',
    category: Category.ColorAndPaddings,
    uiSelectorType: UISelectorType.defaultSelector,
  },
  {
    id: 'backgroundSize',
    displayName: 'Background Size',
    category: Category.ColorAndPaddings,
    uiSelectorType: UISelectorType.defaultSelector,
    containerName: "UI"
  },
  {
    id: 'backgroundPosition',
    displayName: 'Background Position',
    category: Category.ColorAndPaddings,
    uiSelectorType: UISelectorType.defaultSelector,
    containerName: "UI"
  },
  {
    id: 'backgroundRepeat',
    displayName: 'Background Repeat',
    category: Category.ColorAndPaddings,
    uiSelectorType: UISelectorType.defaultSelector,
    containerName: "UI"
  },
  // { id: 'cardEmphasisBackgroundColor',        
  //   displayName: 'Card Emphasis Background Color',
  //   category: Category.ColorAndPaddings,
  //   uiSelectorType: UISelectorType.colorSelector,
  // },
  {
    id: 'paddingRegular',
    displayName: 'Padding Regular',
    category: Category.ColorAndPaddings,
    uiSelectorType: UISelectorType.integerSelector,
  },
  // { // removed because not used anymore
  //   id: 'paddingWide',
  //   displayName: 'Padding Wide',
  //   category: Category.ColorAndPaddings,
  //   uiSelectorType: UISelectorType.integerSelector,
  // },
  {
    id: 'subtle',
    displayName: 'Subtle',
    category: Category.ColorAndPaddings,
    uiSelectorType: UISelectorType.colorSelector,
  },
];

const fontEntries: CustomizationEntry[] = [
  {
    id: 'fontSizeSmall',
    displayName: 'Font Size Small',
    category: Category.Fonts,
    uiSelectorType: UISelectorType.percentageSelector,
  },
  // {
  //   id: 'monospaceFont',
  //   displayName: 'Monospace Font',
  //   category: Category.Fonts,
  //   uiSelectorType: UISelectorType.dropDownSelector,
  // },
  {
    id: 'primaryFont',
    displayName: 'Primary Font',
    category: Category.Fonts,
    uiSelectorType: UISelectorType.dropDownSelector,
  },
  {
    id: 'rootFontSize',
    displayName: 'Root Font Size',
    category: Category.Fonts,
    containerName: "UI",
    uiSelectorType: UISelectorType.defaultSelector,
  },
  {
    id: 'transcriptFontSize',
    displayName: 'Transcript Font Size',
    category: Category.Fonts,
    containerName: "UI",
    uiSelectorType: UISelectorType.defaultSelector,
  },
  {
    id: 'headerFontSize',
    displayName: 'Header Font Size',
    category: Category.Fonts,
    containerName: "UI",
    uiSelectorType: UISelectorType.defaultSelector,
  },
  {
    id: 'sendBoxFontSize',
    displayName: 'SendBox Font Size',
    category: Category.Fonts,
    containerName: "UI",
    uiSelectorType: UISelectorType.defaultSelector,
  },
  {
    id: 'lineHeight',
    displayName: 'Line Height - in REM',
    category: Category.Fonts,
    containerName: "UI",
    uiSelectorType: UISelectorType.defaultSelector,
  },
  {
    id: 'messageActivityWordBreak',
    displayName: 'Message Activity Word Break',
    category: Category.Fonts,
    uiSelectorType: UISelectorType.dropDownSelector,
  },
];

const avatarEntries: CustomizationEntry[] = [
  {
    id: 'avatarBorderRadius',
    displayName: 'Avatar Border Radius',
    category: Category.Avatar,
    subCategory: SubCategory.AvatarSettings,
    uiSelectorType: UISelectorType.percentageSelector,
  },
  {
    id: 'avatarSize',
    displayName: 'Avatar Size',
    category: Category.Avatar,
    subCategory: SubCategory.AvatarSettings,
    uiSelectorType: UISelectorType.integerSelector,
  },
  {
    id: 'botAvatarBackgroundColor',
    displayName: 'Background Color',
    category: Category.Avatar,
    subCategory: SubCategory.BotAvatar,
    uiSelectorType: UISelectorType.rgbaSelector,
  },
  {
    id: 'botAvatarImage',
    displayName: 'Image',
    category: Category.Avatar,
    subCategory: SubCategory.BotAvatar,
    uiSelectorType: UISelectorType.defaultSelector
  },
  {
    id: 'disableBotAvatarChatBubble',
    displayName: 'Disable Bot Avatar in Chat Bubble',
    category: Category.Avatar,
    subCategory: SubCategory.BotAvatar,
    uiSelectorType: UISelectorType.booleanSelector,
  },
  // {
  //   id: 'botAvatarInitials',
  //   displayName: 'Initials',
  //   category: Category.Avatar,
  //   subCategory: SubCategory.BotAvatar,
  //   uiSelectorType: UISelectorType.defaultSelector,
  // },
  {
    id: 'userAvatarBackgroundColor',
    displayName: 'Background Color',
    category: Category.Avatar,
    subCategory: SubCategory.UserAvatar,
    uiSelectorType: UISelectorType.rgbaSelector,
  },
  {
    id: 'userAvatarImage',
    displayName: 'Image',
    category: Category.Avatar,
    subCategory: SubCategory.UserAvatar,
    uiSelectorType: UISelectorType.defaultSelector,
    hidden: ['!disableUserAvatarChatBubble']
  },
  {
    id: 'disableUserAvatarChatBubble',
    displayName: 'Disable User Avatar in Chat Bubble',
    category: Category.Avatar,
    subCategory: SubCategory.UserAvatar,
    uiSelectorType: UISelectorType.booleanSelector,
  },
  // {
  //   id: 'userAvatarInitials',
  //   displayName: 'Initials',
  //   category: Category.Avatar,
  //   subCategory: SubCategory.UserAvatar,
  //   uiSelectorType: UISelectorType.defaultSelector,
  // },
];

const buttonsEntries: CustomizationEntry[] = [
  {
    id: 'buttonsPadding',
    displayName: 'Padding',
    category: Category.Buttons,
    subCategory: SubCategory.Layout,
    uiSelectorType: UISelectorType.integerSelector,
    containerName: "UI"
  },
  {
    id: 'buttonsBorderRadius',
    displayName: 'Border Radius',
    category: Category.Buttons,
    subCategory: SubCategory.Layout,

    uiSelectorType: UISelectorType.integerSelector,
    containerName: "UI"
  },
  {
    id: 'buttonsTextColor',
    displayName: 'Text Color',
    category: Category.Buttons,
    subCategory: SubCategory.Colors,

    uiSelectorType: UISelectorType.colorSelector,
    containerName: "UI"
  },
  {
    id: 'buttonsBorderColor',
    displayName: 'Border Color',
    category: Category.Buttons,
    subCategory: SubCategory.Colors,

    uiSelectorType: UISelectorType.colorSelector,
    containerName: "UI"
  },
  {
    id: 'buttonsBackgroundColor',
    displayName: 'Background Color',
    category: Category.Buttons,
    subCategory: SubCategory.Colors,

    uiSelectorType: UISelectorType.colorSelector,
    containerName: "UI"
  },
  {
    id: 'buttonsBackgroundColorOnHover',
    displayName: 'Hover Background Color',
    category: Category.Buttons,
    subCategory: SubCategory.Colors,
    uiSelectorType: UISelectorType.colorSelector,
    containerName: "UI"
  },
  {
    id: 'buttonsTextColorOnHover',
    displayName: 'Hover Text Color',
    category: Category.Buttons,
    subCategory: SubCategory.Colors,

    uiSelectorType: UISelectorType.colorSelector,
    containerName: "UI"
  },
  {
    id: 'buttonsBorderColorOnHover',
    displayName: 'Hover Border Color',
    category: Category.Buttons,
    subCategory: SubCategory.Colors,

    uiSelectorType: UISelectorType.colorSelector,
    containerName: "UI"
  },
  {
    id: 'shellPaddingTopBottom',
    displayName: 'Shell Padding Top and Bottom',
    category: Category.Layout,
    subCategory: SubCategory.Layout,
    uiSelectorType: UISelectorType.integerSelector,
    containerName: "UI"
  },
  {
    id: 'shellPaddingLeftRight',
    displayName: 'Shell Padding Left and Right',
    category: Category.Layout,
    subCategory: SubCategory.Layout,
    uiSelectorType: UISelectorType.integerSelector,
    containerName: "UI"
  },
  {
    id: 'v2_contextMenu_icon',
    displayName: 'Context menu icon',
    category: Category.Buttons,
    subCategory: SubCategory.Icons,
    uiSelectorType: UISelectorType.defaultSelector,
    multiline: true,
    containerName: "UI"
  },
  {
    id: 'v2_minimize_icon',
    displayName: 'Minimize icon',
    category: Category.Buttons,
    subCategory: SubCategory.Icons,
    uiSelectorType: UISelectorType.defaultSelector,
    multiline: true,
    containerName: "UI"
  },
  {
    id: 'v2_send_icon',
    displayName: 'Send icon',
    category: Category.Buttons,
    subCategory: SubCategory.Icons,
    uiSelectorType: UISelectorType.defaultSelector,
    multiline: true,
    containerName: "UI"
  },
  {
    id: 'v2_microphone_icon',
    displayName: 'Microphone icon',
    category: Category.Buttons,
    subCategory: SubCategory.Icons,
    uiSelectorType: UISelectorType.defaultSelector,
    multiline: true,
    containerName: "UI"
  },
  {
    id: 'v2_upload_icon',
    displayName: 'Upload icon',
    category: Category.Buttons,
    subCategory: SubCategory.Icons,
    uiSelectorType: UISelectorType.defaultSelector,
    multiline: true,
    containerName: "UI"
  },
  {
    id: 'v2_emoji_icon',
    displayName: 'Emoji icon',
    category: Category.Buttons,
    subCategory: SubCategory.Icons,
    uiSelectorType: UISelectorType.defaultSelector,
    multiline: true,
    containerName: "UI"
  },
  {
    id: 'v2_stop_icon',
    displayName: 'Stop icon',
    category: Category.Buttons,
    subCategory: SubCategory.Icons,
    uiSelectorType: UISelectorType.defaultSelector,
    multiline: true,
    containerName: "UI"
  },
  {
    id: 'v2_removeAttachment_icon',
    displayName: 'Remove attachment icon',
    category: Category.Buttons,
    subCategory: SubCategory.Icons,
    uiSelectorType: UISelectorType.defaultSelector,
    multiline: true,
    containerName: "UI"
  },
  {
    id: 'v2_login_icon',
    displayName: 'Login icon',
    category: Category.Buttons,
    subCategory: SubCategory.Icons,
    uiSelectorType: UISelectorType.defaultSelector,
    multiline: true,
    containerName: "UI"
  },
  {
    id: 'v2_logout_icon',
    displayName: 'Logout icon',
    category: Category.Buttons,
    subCategory: SubCategory.Icons,
    uiSelectorType: UISelectorType.defaultSelector,
    multiline: true,
    containerName: "UI"
  },
  {
    id: 'v2_optionsMenu_icon',
    displayName: 'Options menu icon',
    category: Category.Buttons,
    subCategory: SubCategory.Icons,
    uiSelectorType: UISelectorType.defaultSelector,
    multiline: true,
    containerName: "UI"
  },
  {
    id: 'v2_reload_icon',
    displayName: 'Reload icon',
    category: Category.Buttons,
    subCategory: SubCategory.Icons,
    uiSelectorType: UISelectorType.defaultSelector,
    multiline: true,
    containerName: "UI"
  },
  {
    id: 'v2_reset_icon',
    displayName: 'Reset icon',
    category: Category.Buttons,
    subCategory: SubCategory.Icons,
    uiSelectorType: UISelectorType.defaultSelector, 
    multiline: true,
    containerName: "UI"
  },
  {
    id: 'v2_changeSide_icon',
    displayName: 'Change side icon',
    category: Category.Buttons,
    subCategory: SubCategory.Icons,
    uiSelectorType: UISelectorType.defaultSelector,
    multiline: true,
    containerName: "UI"
  },
  {
    id: 'v2_containerElement_expand_icon',
    displayName: 'Expand chat icon',
    category: Category.Buttons,
    subCategory: SubCategory.Icons,
    uiSelectorType: UISelectorType.defaultSelector,
    multiline: true,
    containerName: "UI"
  },
  {
    id: 'v2_containerElement_collapse_icon',
    displayName: 'Collapse chat icon',
    category: Category.Buttons,
    subCategory: SubCategory.Icons,
    uiSelectorType: UISelectorType.defaultSelector,
    multiline: true,
    containerName: "UI"
  },
  {
    id: 'v2_header_custom_icon',
    displayName: 'Header custom icon',
    category: Category.Buttons,
    subCategory: SubCategory.Icons,
    uiSelectorType: UISelectorType.defaultSelector,
    multiline: true,
    containerName: "UI"
  },
  {
    id: 'containerElementBannerEnabled',
    displayName: 'Enable banner',
    category: Category.Buttons,
    subCategory: SubCategory.Icons,
    uiSelectorType: UISelectorType.booleanSelector,
    containerName: "UI"
  },
  {
    id: 'containerElementBannerDelayInSeconds',
    displayName: 'Banner delay',
    category: Category.Buttons,
    subCategory: SubCategory.Icons,
    uiSelectorType: UISelectorType.integerSelector,
    containerName: "UI"
  },
  {
    id: 'containerElementFirstBannerRowHtml',
    displayName: 'Banner first row HTML code',
    category: Category.Buttons,
    subCategory: SubCategory.Icons,
    uiSelectorType: UISelectorType.defaultSelector,
    multiline: true,
    containerName: "UI"
  },
  {
    id: 'containerElementSecondBannerRowHtml',
    displayName: 'Banner second row HTML code',
    category: Category.Buttons,
    subCategory: SubCategory.Icons,
    uiSelectorType: UISelectorType.defaultSelector,
    multiline: true,
    containerName: "UI"
  },
  {
    id: 'containerElementBannerDismissButtonEnabled',
    displayName: 'Banner show dismiss button',
    category: Category.Buttons,
    subCategory: SubCategory.Icons,
    uiSelectorType: UISelectorType.booleanSelector,
    containerName: "UI"
  },
  {
    id: 'containerElementBannerPersistDismiss',
    displayName: 'Banner persist the dismiss action',
    category: Category.Buttons,
    subCategory: SubCategory.Icons,
    uiSelectorType: UISelectorType.booleanSelector,
    containerName: "UI"
  },
];

const chatBubbleEntries: CustomizationEntry[] = [
  {
    id: 'druidSendBoxReplyToModeBackgroundColor',
    displayName: 'Send Box Reply Backgorund Color',
    category: Category.ChatBubble,
    subCategory: SubCategory.ReplyTo,
    uiSelectorType: UISelectorType.colorSelector,
    containerName: "UI"
  },
    {
    id: 'druidSendBoxReplyToModePadding',
    displayName: 'Reply Chat Bubble Padding',
    category: Category.ChatBubble,
    subCategory: SubCategory.ReplyTo,
    uiSelectorType: UISelectorType.integerSelector,
    containerName: "UI"
  },
    {
    id: 'druidSendBoxReplyToModeBorderRadius',
    displayName: 'Reply Chat Bubble Border Radius',
    category: Category.ChatBubble,
    subCategory: SubCategory.ReplyTo,
    uiSelectorType: UISelectorType.integerSelector,
    containerName: "UI"
  },
    {
    id: 'druidSendBoxReplyToModeBorderWidth',
    displayName: 'Reply Chat Bubble Border Width',
    category: Category.ChatBubble,
    subCategory: SubCategory.ReplyTo,
    uiSelectorType: UISelectorType.integerSelector,
    containerName: "UI"
  },
    {
    id: 'druidSendBoxReplyToModeBorderColor',
    displayName: 'Reply Chat Bubble Border Color',
    category: Category.ChatBubble,
    subCategory: SubCategory.ReplyTo,
    uiSelectorType: UISelectorType.colorSelector,
    containerName: "UI"
  },
  {
    id: 'druidSendBoxReplyToModeMarginBottom',
    displayName: 'Reply Chat Bubble Margin Bottom',
    category: Category.ChatBubble,
    subCategory: SubCategory.ReplyTo,
    uiSelectorType: UISelectorType.integerSelector,
    containerName: "UI"
  },
  {
    id: 'druidSendBoxReplyToModeMarginTop',
    displayName: 'Reply Chat Bubble Margin Top',
    category: Category.ChatBubble,
    subCategory: SubCategory.ReplyTo,
    uiSelectorType: UISelectorType.integerSelector,
    containerName: "UI"
  },
  {
    id: 'druidSendBoxReplyButtonColor',
    displayName: 'Reply Button Color',
    category: Category.ChatBubble,
    subCategory: SubCategory.ReplyTo,
    uiSelectorType: UISelectorType.colorSelector,
    containerName: "UI"
  },
  {
    id: 'druidSendBoxReplyButtonColorOnHover',
    displayName: 'Reply Button Color On Hover',
    category: Category.ChatBubble,
    subCategory: SubCategory.ReplyTo,
    uiSelectorType: UISelectorType.colorSelector,
    containerName: "UI"
  },
  {
    id: 'druidSendBoxReplyButtonColorOnFocus',
    displayName: 'Reply Button Color On Focus',
    category: Category.ChatBubble,
    subCategory: SubCategory.ReplyTo,
    uiSelectorType: UISelectorType.colorSelector,
    containerName: "UI"
  },
  {
    id: 'druidSendBoxReplyButtonIconColor',
    displayName: 'Reply Button Icon Color',
    category: Category.ChatBubble,
    subCategory: SubCategory.ReplyTo,
    uiSelectorType: UISelectorType.colorSelector,
    containerName: "UI"
  },
  {
    id: 'druidSendBoxReplyButtonIconColorOnHover',
    displayName: 'Reply Button Icon Color On Hover',
    category: Category.ChatBubble,
    subCategory: SubCategory.ReplyTo,
    uiSelectorType: UISelectorType.colorSelector,
    containerName: "UI"
  },
  {
    id: 'druidSendBoxReplyButtonIconColorOnFocus',
    displayName: 'Reply Button Icon Color On Focus',
    category: Category.ChatBubble,
    subCategory: SubCategory.ReplyTo,
    uiSelectorType: UISelectorType.colorSelector,
    containerName: "UI"
  },
  {
    id: 'druidSendBoxReplyCancelButtonColor',
    displayName: 'Reply Cancel Button Color',
    category: Category.ChatBubble,
    subCategory: SubCategory.ReplyTo,
    uiSelectorType: UISelectorType.colorSelector,
    containerName: "UI"
  },
  {
    id: 'druidSendBoxReplyCancelButtonColorOnHover',
    displayName: 'Reply Cancel Button Color On Hover',
    category: Category.ChatBubble,
    subCategory: SubCategory.ReplyTo,
    uiSelectorType: UISelectorType.colorSelector,
    containerName: "UI"
  },
  {
    id: 'bubbleBackground',
    displayName: 'Background',
    category: Category.ChatBubble,
    subCategory: SubCategory.AvatarChatBubble,
    uiSelectorType: UISelectorType.colorSelector,
  },
  {
    id: 'bubbleTextColor',
    displayName: 'Text Color',
    category: Category.ChatBubble,
    subCategory: SubCategory.AvatarChatBubble,
    uiSelectorType: UISelectorType.colorSelector,
  },
  {
    id: 'bubbleBorderColor',
    displayName: 'Border Color',
    category: Category.ChatBubble,
    subCategory: SubCategory.AvatarChatBubble,
    uiSelectorType: UISelectorType.colorSelector,
  },
  {
    id: 'bubblePaddingTopBottom',
    displayName: 'Padding Top and Bottom',
    category: Category.ChatBubble,
    subCategory: SubCategory.AvatarChatBubble,
    uiSelectorType: UISelectorType.integerSelector,
  },
  {
    id: 'bubblePaddingLeftRight',
    displayName: 'Padding Left and Right',
    category: Category.ChatBubble,
    subCategory: SubCategory.AvatarChatBubble,
    uiSelectorType: UISelectorType.integerSelector,
  },
  {
    id: 'bubbleBorderRadius',
    displayName: 'Border Radius',
    category: Category.ChatBubble,
    subCategory: SubCategory.AvatarChatBubble,
    uiSelectorType: UISelectorType.integerSelector,
  },
  {
    id: 'bubbleBorderStyle',
    displayName: 'Border Style',
    category: Category.ChatBubble,
    subCategory: SubCategory.AvatarChatBubble,
    uiSelectorType: UISelectorType.dropDownSelector,
  },
  {
    id: 'bubbleBorderWidth',
    displayName: 'Border Width',
    category: Category.ChatBubble,
    subCategory: SubCategory.AvatarChatBubble,
    uiSelectorType: UISelectorType.integerSelector,
  },
  {
    id: 'bubbleNubSize',
    displayName: 'Nub Size',
    category: Category.ChatBubble,
    subCategory: SubCategory.AvatarChatBubble,
    uiSelectorType: UISelectorType.integerSelector,
  },
  {
    id: 'bubbleNubOffset',
    displayName: 'Nub Offset',
    category: Category.ChatBubble,
    subCategory: SubCategory.AvatarChatBubble,
    uiSelectorType: UISelectorType.dropDownSelector,
  },
  {
    id: 'bubbleFromUserBackground',
    displayName: 'Background',
    category: Category.ChatBubble,
    subCategory: SubCategory.UserChatBubble,
    uiSelectorType: UISelectorType.colorSelector,
  },
  {
    id: 'bubbleFromUserTextColor',
    displayName: 'Text Color',
    category: Category.ChatBubble,
    subCategory: SubCategory.UserChatBubble,
    uiSelectorType: UISelectorType.colorSelector,
  },
  {
    id: 'bubbleFromUserBorderColor',
    displayName: 'Border Color',
    category: Category.ChatBubble,
    subCategory: SubCategory.UserChatBubble,
    uiSelectorType: UISelectorType.colorSelector,
  },
  {
    id: 'bubbleFromUserPaddingTopBottom',
    displayName: 'Padding Top and Bottom',
    category: Category.ChatBubble,
    subCategory: SubCategory.UserChatBubble,
    uiSelectorType: UISelectorType.integerSelector,
  },
  {
    id: 'bubbleFromUserPaddingLeftRight',
    displayName: 'Padding Left and Right',
    category: Category.ChatBubble,
    subCategory: SubCategory.UserChatBubble,
    uiSelectorType: UISelectorType.integerSelector,
  },
  {
    id: 'bubbleFromUserBorderRadius',
    displayName: 'Border Radius',
    category: Category.ChatBubble,
    subCategory: SubCategory.UserChatBubble,
    uiSelectorType: UISelectorType.integerSelector,
  },
  {
    id: 'bubbleFromUserBorderStyle',
    displayName: 'Border Style',
    category: Category.ChatBubble,
    subCategory: SubCategory.UserChatBubble,
    uiSelectorType: UISelectorType.dropDownSelector,
  },
  {
    id: 'bubbleFromUserBorderWidth',
    displayName: 'Border Width',
    category: Category.ChatBubble,
    subCategory: SubCategory.UserChatBubble,
    uiSelectorType: UISelectorType.integerSelector,
  },
  {
    id: 'bubbleFromUserNubSize',
    displayName: 'Nub Size',
    category: Category.ChatBubble,
    subCategory: SubCategory.UserChatBubble,
    uiSelectorType: UISelectorType.integerSelector,
  },
  {
    id: 'bubbleFromUserNubOffset',
    displayName: 'Nub Offset',
    category: Category.ChatBubble,
    subCategory: SubCategory.UserChatBubble,
    uiSelectorType: UISelectorType.dropDownSelector,
  },
  {
    id: 'bubbleImageMaxHeight',
    displayName: 'Image Max Height',
    category: Category.ChatBubble,
    subCategory: SubCategory.Layout,
    uiSelectorType: UISelectorType.integerSelector,
  },
  {
    id: 'bubbleImageMinHeight',
    displayName: 'Image Min Height',
    category: Category.ChatBubble,
    subCategory: SubCategory.Layout,
    uiSelectorType: UISelectorType.integerSelector,
  },
  {
    id: 'bubbleAttachmentMaxWidth',
    displayName: 'Attachment Max Width',
    category: Category.ChatBubble,
    subCategory: SubCategory.Layout,
    uiSelectorType: UISelectorType.integerSelector,
  },
  {
    id: 'bubbleMessageMaxWidth',
    displayName: 'Message Max Width (Percentage)',
    category: Category.ChatBubble,
    subCategory: SubCategory.Layout,
    uiSelectorType: UISelectorType.percentageSelector,
  },
  {
    id: 'bubbleMessageMinWidth',
    displayName: 'Message Min Width (Percentage)',
    category: Category.ChatBubble,
    subCategory: SubCategory.Layout,
    uiSelectorType: UISelectorType.percentageSelector,
  },
  {
    id: 'bubbleMinHeight',
    displayName: 'Min Height',
    category: Category.ChatBubble,
    subCategory: SubCategory.Layout,
    uiSelectorType: UISelectorType.integerSelector,
  },
  {
    id: 'bubbleAttachmentMinWidth',
    displayName: 'Attachment Min Width',
    category: Category.ChatBubble,
    subCategory: SubCategory.Layout,
    uiSelectorType: UISelectorType.integerSelector,
  },
];

const sendBoxEntries: CustomizationEntry[] = [
  {
    id: 'druidSendBoxMaxWidth',
    displayName: 'Max Width',
    category: Category.SendBox,
    subCategory: SubCategory.Layout,
    uiSelectorType: UISelectorType.defaultSelector,
    containerName: "UI"
  },
  {
    id: 'sendBoxHeight',
    displayName: 'Height',
    category: Category.SendBox,
    subCategory: SubCategory.Layout,
    uiSelectorType: UISelectorType.integerSelector,
  },
  {
    id: 'sendBoxIconSize',
    displayName: 'Button Icon Size',
    category: Category.SendBox,
    subCategory: SubCategory.Layout,
    uiSelectorType: UISelectorType.integerSelector,
  },
  {
    id: 'sendBoxMaxHeight',
    displayName: 'Max Height',
    category: Category.SendBox,
    subCategory: SubCategory.Layout,
    uiSelectorType: UISelectorType.integerSelector,
  },
  {
    id: 'druidSendBoxPaddingLeftRight',
    displayName: 'Padding Left and Right',
    category: Category.SendBox,
    subCategory: SubCategory.Layout,
    uiSelectorType: UISelectorType.integerSelector,
    containerName: "UI"
  },
  {
    id: 'druidSendBoxPaddingTop',
    displayName: 'Padding Top',
    category: Category.SendBox,
    subCategory: SubCategory.Layout,
    uiSelectorType: UISelectorType.integerSelector,
    containerName: "UI"
  },
  {
    id: 'druidSendBoxPaddingBottom',
    displayName: 'Padding Bottom',
    category: Category.SendBox,
    subCategory: SubCategory.Layout,
    uiSelectorType: UISelectorType.integerSelector,
    containerName: "UI"
  },

  {
    id: 'druidSendBoxTextBoxPadding',
    displayName: 'Inner padding',
    category: Category.SendBox,
    subCategory: SubCategory.Layout,
    uiSelectorType: UISelectorType.integerSelector,
    containerName: "UI"
  },
  {
    id: 'druidSendBoxInnerPaddingLeftRight',
    displayName: 'Inner padding Left and Right',
    category: Category.SendBox,
    subCategory: SubCategory.Layout,
    uiSelectorType: UISelectorType.integerSelector,
    containerName: "UI"
  },
  {
    id: 'druidSendBoxInnerPaddingTopBottom',
    displayName: 'Inner padding Top and Bottom',
    category: Category.SendBox,
    subCategory: SubCategory.Layout,
    uiSelectorType: UISelectorType.integerSelector,
    containerName: "UI"
  },
  {
    id: 'druidSendBoxButtonsGap',
    displayName: 'Buttons gap',
    category: Category.SendBox,
    subCategory: SubCategory.Layout,
    uiSelectorType: UISelectorType.integerSelector,
    containerName: "UI"
  },

  // not used -> hidden by default and should stay hidden
  // { id: 'hideSendBox',        
  //   displayName: 'Hide Send Box',        
  //   category: Category.SendBox,
  //   subCategory: SubCategory.Layout,
  //   uiSelectorType: UISelectorType.booleanSelector,
  // },
  {
    id: 'hideDruidSendBox',
    displayName: 'Hide Send Box',
    category: Category.SendBox,
    subCategory: SubCategory.Layout,
    uiSelectorType: UISelectorType.booleanSelector,
    containerName: "UI"
  },
  {
    id: 'disableFileUpload',
    displayName: 'Disable File Upload',
    category: Category.SendBox,
    subCategory: SubCategory.Layout,
    uiSelectorType: UISelectorType.booleanSelector,
  },
  {
    id: 'emojiPickerEnabled',
    displayName: 'Enable Emoji Picker',
    category: Category.SendBox,
    subCategory: SubCategory.Layout,
    uiSelectorType: UISelectorType.booleanSelector,
    containerName: "UI"
  },
  {
    id: 'replyToMessageEnabled',
    displayName: 'Enable replying to messages',
    category: Category.SendBox,
    subCategory: SubCategory.Layout,
    uiSelectorType: UISelectorType.booleanSelector,
    containerName: "UI"
  },
  {
    id: 'inputBetweenActionButtons',
    displayName: 'Input Between Action Buttons',
    category: Category.SendBox,
    subCategory: SubCategory.Layout,
    uiSelectorType: UISelectorType.booleanSelector,
    containerName: "UI"
  },
  {
    id: 'sendBoxTextWrap',
    displayName: 'Text Wrap',
    category: Category.SendBox,
    subCategory: SubCategory.Layout,
    uiSelectorType: UISelectorType.booleanSelector
  },
  {
    id: 'sendBoxTextColor',
    displayName: 'Text Color',
    category: Category.SendBox,
    subCategory: SubCategory.Colors,
    uiSelectorType: UISelectorType.colorSelector,
  },
  {
    id: 'sendBoxBackground',
    displayName: 'Background Color',
    category: Category.SendBox,
    subCategory: SubCategory.Colors,
    uiSelectorType: UISelectorType.colorSelector,

  },
  {
    id: 'sendBoxDisabledTextColor',
    displayName: 'Disabled Text Color',
    category: Category.SendBox,
    subCategory: SubCategory.Colors,
    uiSelectorType: UISelectorType.colorSelector,
  },
  {
    id: 'sendBoxPlaceholderColor',
    displayName: 'Placeholder Color',
    category: Category.SendBox,
    subCategory: SubCategory.Colors,
    uiSelectorType: UISelectorType.colorSelector,
  },
  {
    id: 'sendBoxButtonColor',
    displayName: 'Default',
    category: Category.SendBox,
    subCategory: SubCategory.ButtonColors,
    uiSelectorType: UISelectorType.colorSelector,
  },
  {
    id: 'sendBoxButtonColorOnDisabled',
    displayName: 'On Disabled',
    category: Category.SendBox,
    subCategory: SubCategory.ButtonColors,
    uiSelectorType: UISelectorType.colorSelector,
  },
  {
    id: 'sendBoxButtonColorOnFocus',
    displayName: 'On Focus',
    category: Category.SendBox,
    subCategory: SubCategory.ButtonColors,
    uiSelectorType: UISelectorType.colorSelector,
  },
  {
    id: 'sendBoxButtonColorOnHover',
    displayName: 'On Hover',
    category: Category.SendBox,
    subCategory: SubCategory.ButtonColors,
    uiSelectorType: UISelectorType.colorSelector,
  },
  {
    id: 'microphoneButtonColorOnDictate',
    displayName: 'Microphone Button Color On Dictate',
    category: Category.SendBox,
    subCategory: SubCategory.ButtonColors,
    uiSelectorType: UISelectorType.colorSelector,
  },
  {
    id: 'sendBoxVoiceWaveformColor',
    displayName: 'Voice Waveform Color',
    category: Category.SendBox,
    subCategory: SubCategory.Colors,
    uiSelectorType: UISelectorType.defaultSelector,
  },
  {
    id: 'sendBoxButtonMessageSendColor',
    displayName: 'Message Send Button Color',
    category: Category.SendBox,
    subCategory: SubCategory.ButtonColors,
    uiSelectorType: UISelectorType.colorSelector,
  },
  {
    id: 'sendBoxButtonMessageSendColorOnDisabled',
    displayName: 'Message Send Button Color On Disabled',
    category: Category.SendBox,
    subCategory: SubCategory.ButtonColors,
    uiSelectorType: UISelectorType.colorSelector,
  },
  {
    id: 'sendBoxButtonMessageSendColorOnFocus',
    displayName: 'Message Send Button Color On Focus',
    category: Category.SendBox,
    subCategory: SubCategory.ButtonColors,
    uiSelectorType: UISelectorType.colorSelector,
  },
  {
    id: 'sendBoxButtonMessageSendColorOnHover',
    displayName: 'Message Send Button Color On Hover',
    category: Category.SendBox,
    subCategory: SubCategory.ButtonColors,
    uiSelectorType: UISelectorType.colorSelector,
  },
  {
    id: 'druidSendBoxButtonBackgroundColorOnHover',
    displayName: 'Send Box Button Background Color On Hover',
    category: Category.SendBox,
    subCategory: SubCategory.ButtonColors,
    uiSelectorType: UISelectorType.colorSelector,
  },
  {
    id: 'druidSendBoxButtonBackgroundColorOnFocus',
    displayName: 'Send Box Button Background Color On Focus',
    category: Category.SendBox,
    subCategory: SubCategory.ButtonColors,
    uiSelectorType: UISelectorType.colorSelector,
  },
  {
    id: 'sendBoxBorderBottom',
    displayName: 'Bottom',
    category: Category.SendBox,
    subCategory: SubCategory.Border,
    uiSelectorType: UISelectorType.defaultSelector,
  },
  {
    id: 'sendBoxBorderLeft',
    displayName: 'Left',
    category: Category.SendBox,
    subCategory: SubCategory.Border,
    uiSelectorType: UISelectorType.defaultSelector,
  },
  {
    id: 'sendBoxBorderRight',
    displayName: 'Right',
    category: Category.SendBox,
    subCategory: SubCategory.Border,
    uiSelectorType: UISelectorType.defaultSelector,
  },
  {
    id: 'sendBoxBorderTop',
    displayName: 'Top',
    category: Category.SendBox,
    subCategory: SubCategory.Border,
    uiSelectorType: UISelectorType.defaultSelector,
  },
  {
    id: 'druidSendBoxInnerBorderRadius',
    displayName: 'Inner Border Radius',
    category: Category.SendBox,
    subCategory: SubCategory.Border,
    uiSelectorType: UISelectorType.integerSelector,
    containerName: "UI"
  },
];

const suggestedActionsEntries: CustomizationEntry[] = [
  {
    id: 'suggestedActionBackgroundColor',
    displayName: 'Background Color',
    category: Category.SuggestedActions,
    subCategory: SubCategory.Colors,
    uiSelectorType: UISelectorType.colorSelector,
  },
  {
    id: 'suggestedActionBackgroundColorOnHover',
    displayName: 'Background Color (Hover)',
    category: Category.SuggestedActions,
    subCategory: SubCategory.Colors,
    uiSelectorType: UISelectorType.colorSelector,
  },
  {
    id: 'suggestedActionTextColor',
    displayName: 'Color',
    category: Category.SuggestedActions,
    subCategory: SubCategory.Colors,
    uiSelectorType: UISelectorType.colorSelector,
  },
  {
    id: 'suggestedActionDisabledBackground',
    displayName: 'Background Color (Disabled)',
    category: Category.SuggestedActions,
    subCategory: SubCategory.Colors,
    uiSelectorType: UISelectorType.colorSelector,
  },
  {
    id: 'suggestedActionDisabledTextColor',
    displayName: 'Text Color (Disabled)',
    category: Category.SuggestedActions,
    subCategory: SubCategory.Colors,
    uiSelectorType: UISelectorType.colorSelector,
  },
  {
    id: 'suggestedActionBorderColor',
    displayName: 'Border',
    category: Category.SuggestedActions,
    subCategory: SubCategory.Border,
    uiSelectorType: UISelectorType.colorSelector,
  },
  {
    id: 'suggestedActionBorderRadius',
    displayName: 'Radius',
    category: Category.SuggestedActions,
    subCategory: SubCategory.Border,
    uiSelectorType: UISelectorType.integerSelector,
  },
  {
    id: 'suggestedActionBorderStyle',
    displayName: 'Style',
    category: Category.SuggestedActions,
    subCategory: SubCategory.Border,
    uiSelectorType: UISelectorType.dropDownSelector,
  },
  {
    id: 'suggestedActionBorderWidth',
    displayName: 'Width',
    category: Category.SuggestedActions,
    subCategory: SubCategory.Border,
    uiSelectorType: UISelectorType.integerSelector,
  },
  // {
  //   id: 'suggestedActionDisabledBackground',
  //   displayName: 'Color',
  //   category: Category.SuggestedActions,
  //   subCategory: SubCategory.BorderDisabled,
  //   uiSelectorType: UISelectorType.colorSelector,
  // },
  {
    id: 'suggestedActionDisabledBorderColor',
    displayName: 'Border',
    category: Category.SuggestedActions,
    subCategory: SubCategory.BorderDisabled,
    uiSelectorType: UISelectorType.colorSelector,
  },
  //MM: NOT USED
  // { 
  //   id: 'suggestedActionDisabledBorderRadius',
  //   displayName: 'Radius',
  //   category: Category.SuggestedActions,
  //   subCategory: SubCategory.BorderDisabled,
  //   uiSelectorType: UISelectorType.integerSelector,
  // },
  {
    id: 'suggestedActionDisabledBorderStyle',
    displayName: 'Style',
    category: Category.SuggestedActions,
    subCategory: SubCategory.BorderDisabled,
    uiSelectorType: UISelectorType.dropDownSelector,
  },
  {
    id: 'suggestedActionDisabledBorderWidth',
    displayName: 'Width',
    category: Category.SuggestedActions,
    subCategory: SubCategory.BorderDisabled,
    uiSelectorType: UISelectorType.integerSelector,
  },
  {
    id: 'suggestedActionHeight',
    displayName: 'Height',
    category: Category.SuggestedActions,
    subCategory: SubCategory.Layout,
    uiSelectorType: UISelectorType.integerSelector,
  },
  // {
  //   id: 'suggestedActionImageHeight',
  //   displayName: 'Image Height',
  //   category: Category.SuggestedActions,
  //   subCategory: SubCategory.Layout,
  //   uiSelectorType: UISelectorType.integerSelector,
  // },
  {
    id: 'suggestedActionLayout',
    displayName: 'Layout',
    category: Category.SuggestedActions,
    subCategory: SubCategory.Layout,
    uiSelectorType: UISelectorType.dropDownSelector,
  },
  //MM: REMOVED
  // {
  //   id: 'suggestedActionsCarouselFlipperCursor',
  //   displayName: 'Cursor',
  //   category: Category.SuggestedActions,
  //   subCategory: SubCategory.CarouselFlipper,
  //   uiSelectorType: UISelectorType.dropDownSelector,
  // },
  {
    id: 'suggestedActionsCarouselFlipperBoxWidth',
    displayName: 'Box Width',
    category: Category.SuggestedActions,
    subCategory: SubCategory.CarouselFlipper,
    uiSelectorType: UISelectorType.integerSelector,
  },
  {
    id: 'suggestedActionsCarouselFlipperSize',
    displayName: 'Size',
    category: Category.SuggestedActions,
    subCategory: SubCategory.CarouselFlipper,
    uiSelectorType: UISelectorType.integerSelector,
  },
  {
    id: 'suggestedActionsStackedHeight',
    displayName: "Max Height (0 value for auto)",
    category: Category.SuggestedActions,
    subCategory: SubCategory.Container,
    uiSelectorType: UISelectorType.integerSelector,
  },
  // MM: REMOVED
  // {
  //   id: 'suggestedActionsStackedOverflow',
  //   displayName: "Overflow Setting",
  //   category: Category.SuggestedActions,
  //   subCategory: SubCategory.Container,
  //   uiSelectorType: UISelectorType.dropDownSelector,
  // },
];

const timestampAndStatusEntries: CustomizationEntry[] = [
  {
    id: 'groupTimestamp',
    displayName: "Group Timestamp",
    category: Category.TimestampAndStatus,
    subCategory: SubCategory.TimeStamp,
    uiSelectorType: UISelectorType.booleanSelector,
  },
  {
    id: 'sendTimeout',
    displayName: "Send Timeout",
    category: Category.TimestampAndStatus,
    subCategory: SubCategory.TimeStamp,
    uiSelectorType: UISelectorType.integerSelector,
  },
  {
    id: 'sendTimeoutForAttachments',
    displayName: "Send Timeout for Attachments",
    category: Category.TimestampAndStatus,
    subCategory: SubCategory.TimeStamp,
    uiSelectorType: UISelectorType.integerSelector,
  },
  {
    id: 'timestampColor',
    displayName: "Color",
    category: Category.TimestampAndStatus,
    subCategory: SubCategory.TimeStamp,
    uiSelectorType: UISelectorType.colorSelector,
  },
  {
    id: 'timestampFormat',
    displayName: "Format",
    category: Category.TimestampAndStatus,
    subCategory: SubCategory.TimeStamp,
    uiSelectorType: UISelectorType.dropDownSelector,
  },
  {
    id: 'customTimestampFormat',
    displayName: "Custom Timestamp Format",
    category: Category.TimestampAndStatus,
    subCategory: SubCategory.TimeStamp,
    containerName: "UI",
    uiSelectorType: UISelectorType.defaultSelector,
  },
  //// STATUS
  {
    id: 'activityStatusReadColor',
    displayName: "Status Read Color",
    category: Category.TimestampAndStatus,
    subCategory: SubCategory.Status,
    containerName: "UI",
    uiSelectorType: UISelectorType.colorSelector,
  },
  {
    id: 'activityStatusBotName',
    displayName: "Status Bot Name",
    category: Category.TimestampAndStatus,
    subCategory: SubCategory.Status,
    containerName: "UI",
    uiSelectorType: UISelectorType.defaultSelector,
  },
  {
    id: 'activityStatusShowBotName',
    displayName: "Show Bot Name",
    category: Category.TimestampAndStatus,
    subCategory: SubCategory.Status,
    containerName: "UI",
    uiSelectorType: UISelectorType.booleanSelector,
  },
  {
    id: 'activityStatusUserName',
    displayName: "Status User Name",
    category: Category.TimestampAndStatus,
    subCategory: SubCategory.Status,
    containerName: "UI",
    uiSelectorType: UISelectorType.defaultSelector,
  },

  {
    id: 'activityStatusShowUserName',
    displayName: "Show User Name",
    category: Category.TimestampAndStatus,
    subCategory: SubCategory.Status,
    containerName: "UI",
    uiSelectorType: UISelectorType.booleanSelector,
  },
  {
    id: 'botActivitiesActionsEnabled',
    displayName: "Show Actions for Bot Messages",
    category: Category.TimestampAndStatus,
    subCategory: SubCategory.Status,
    containerName: "UI",
    uiSelectorType: UISelectorType.booleanSelector,
  }
  
];

const trascriptOverlayButtonsEntries: CustomizationEntry[] = [
  {
    id: 'transcriptMaxWidth',
    displayName: "Transcript Max Width",
    category: Category.TranscriptOverlayButtons,
    uiSelectorType: UISelectorType.defaultSelector,
    containerName: "UI"
  },
  {
    id: 'transcriptRowMarginInline',
    displayName: "Inline Margin",
    category: Category.TranscriptOverlayButtons,
    uiSelectorType: UISelectorType.integerSelector,
    containerName: "UI"
  },
  {
    id: 'transcriptOverlayButtonColor',
    displayName: "Color",
    category: Category.TranscriptOverlayButtons,
    subCategory: SubCategory.ButtonDefault,
    uiSelectorType: UISelectorType.colorSelector,
  },
  {
    id: 'transcriptOverlayButtonBackground',
    displayName: "Background Color",
    category: Category.TranscriptOverlayButtons,
    subCategory: SubCategory.ButtonDefault,
    uiSelectorType: UISelectorType.rgbaSelector,
  },
  // {
  //   id: 'newMessagesButtonFontSize',
  //   displayName: "New Message Button Font Size",
  //   category: Category.TranscriptOverlayButtons,
  //   subCategory: SubCategory.ButtonDefault,
  //   uiSelectorType: UISelectorType.percentageSelector,
  // },
  {
    id: 'transcriptOverlayButtonColorOnFocus',
    displayName: "Color",
    category: Category.TranscriptOverlayButtons,
    subCategory: SubCategory.ButtonOnFocus,
    uiSelectorType: UISelectorType.rgbaSelector,
  },
  {
    id: 'transcriptOverlayButtonBackgroundOnFocus',
    displayName: "Background Color",
    category: Category.TranscriptOverlayButtons,
    subCategory: SubCategory.ButtonOnFocus,
    uiSelectorType: UISelectorType.rgbaSelector,
  },
  {
    id: 'transcriptOverlayButtonColorOnHover',
    displayName: "Color",
    category: Category.TranscriptOverlayButtons,
    subCategory: SubCategory.ButtonOnHover,
    uiSelectorType: UISelectorType.rgbaSelector,
  },
  {
    id: 'transcriptOverlayButtonBackgroundOnHover',
    displayName: "Background Color",
    category: Category.TranscriptOverlayButtons,
    subCategory: SubCategory.ButtonOnHover,
    uiSelectorType: UISelectorType.rgbaSelector,
  },
  {
    id: 'scrollToEndButtonBehavior',
    displayName: "Behavior",
    category: Category.TranscriptOverlayButtons,
    subCategory: SubCategory.ScrollToEndButton,
    uiSelectorType: UISelectorType.dropDownSelector,
  },
  {
    id: 'scrollToEndButtonFontSize',
    displayName: "Button Font Size",
    category: Category.TranscriptOverlayButtons,
    subCategory: SubCategory.ScrollToEndButton,
    uiSelectorType: UISelectorType.percentageSelector,
  },
  
];

const connectivityUIEntries: CustomizationEntry[] = [
  // {
  //   id: 'connectivityIconPadding',
  //   displayName: "Icon Padding",
  //   category: Category.ConnectivityUI,
  //   subCategory: SubCategory.ConnectivityStyling,
  //   uiSelectorType: UISelectorType.integerSelector,
  // },
  // {
  //   id: 'connectivityMarginLeftRight',
  //   displayName: "Margin - Left and Right",
  //   category: Category.ConnectivityUI,
  //   subCategory: SubCategory.ConnectivityStyling,
  //   uiSelectorType: UISelectorType.integerSelector,
  // },
  // {
  //   id: 'connectivityMarginTopBottom',
  //   displayName: "Margin - Top and Bottom",
  //   category: Category.ConnectivityUI,
  //   subCategory: SubCategory.ConnectivityStyling,
  //   uiSelectorType: UISelectorType.integerSelector,
  // },
  // {
  //   id: 'connectivityTextSize',
  //   displayName: "Text Size",
  //   category: Category.ConnectivityUI,
  //   subCategory: SubCategory.ConnectivityStyling,
  //   uiSelectorType: UISelectorType.percentageSelector,
  // },
  // {
  //   id: 'failedConnectivity',
  //   displayName: "Failed Connectivity Color",
  //   category: Category.ConnectivityUI,
  //   subCategory: SubCategory.ConnectivityStyling,
  //   uiSelectorType: UISelectorType.colorSelector,
  // },
  // {
  //   id: 'slowConnectivity',
  //   displayName: "Slow Connectivity Color",
  //   category: Category.ConnectivityUI,
  //   subCategory: SubCategory.ConnectivityStyling,
  //   uiSelectorType: UISelectorType.colorSelector,
  // },
  // {
  //   id: 'notificationText',
  //   displayName: "Notification Text Color",
  //   category: Category.ConnectivityUI,
  //   subCategory: SubCategory.ConnectivityStyling,
  //   uiSelectorType: UISelectorType.colorSelector,
  // },
  // {
  //   id: 'typingAnimationBackgroundImage',
  //   displayName: "Background Image (url)",
  //   category: Category.ConnectivityUI,
  //   subCategory: SubCategory.TypingAnimation,
  //   uiSelectorType: UISelectorType.defaultSelector,
  // },
  // {
  //   id: 'typingAnimationDuration',
  //   displayName: "Duration",
  //   category: Category.ConnectivityUI,
  //   subCategory: SubCategory.TypingAnimation,
  //   uiSelectorType: UISelectorType.integerSelector,
  // },
  // {
  //   id: 'typingAnimationHeight',
  //   displayName: "Height",
  //   category: Category.ConnectivityUI,
  //   subCategory: SubCategory.TypingAnimation,
  //   uiSelectorType: UISelectorType.integerSelector,
  // },
  // {
  //   id: 'typingAnimationWidth',
  //   displayName: "Width",
  //   category: Category.ConnectivityUI,
  //   subCategory: SubCategory.TypingAnimation,
  //   uiSelectorType: UISelectorType.integerSelector,
  // },
  // {
  //   id: 'spinnerAnimationBackgroundImage',
  //   displayName: "Background Image (url)",
  //   category: Category.ConnectivityUI,
  //   subCategory: SubCategory.SpinnerAnimation,
  //   uiSelectorType: UISelectorType.dropDownSelector,
  // },
  // {
  //   id: 'spinnerAnimationHeight',
  //   displayName: "Height",
  //   category: Category.ConnectivityUI,
  //   subCategory: SubCategory.SpinnerAnimation,
  //   uiSelectorType: UISelectorType.integerSelector,
  // },
  // {
  //   id: 'spinnerAnimationWidth',
  //   displayName: "Width",
  //   category: Category.ConnectivityUI,
  //   subCategory: SubCategory.SpinnerAnimation,
  //   uiSelectorType: UISelectorType.integerSelector,
  // },
  // {
  //   id: 'spinnerAnimationPadding',
  //   displayName: "Padding",
  //   category: Category.ConnectivityUI,
  //   subCategory: SubCategory.SpinnerAnimation,
  //   uiSelectorType: UISelectorType.integerSelector,
  // },
  // {
  //   id: 'enableUploadThumbnail',
  //   displayName: "Enable",
  //   category: Category.ConnectivityUI,
  //   subCategory: SubCategory.UploadThumbnail,
  //   uiSelectorType: UISelectorType.booleanSelector,
  // },
  // {
  //   id: 'uploadThumbnailContentType',
  //   displayName: "Type",
  //   category: Category.ConnectivityUI,
  //   subCategory: SubCategory.UploadThumbnail,
  //   uiSelectorType: UISelectorType.dropDownSelector,
  // },
  // {
  //   id: 'uploadThumbnailHeight',
  //   displayName: "Height",
  //   category: Category.ConnectivityUI,
  //   subCategory: SubCategory.UploadThumbnail,
  //   uiSelectorType: UISelectorType.integerSelector,
  // },
  // {
  //   id: 'uploadThumbnailWidth',
  //   displayName: "Width",
  //   category: Category.ConnectivityUI,
  //   subCategory: SubCategory.UploadThumbnail,
  //   uiSelectorType: UISelectorType.integerSelector,
  // },
  // {
  //   id: 'uploadThumbnailQuality',
  //   displayName: "Quality",
  //   category: Category.ConnectivityUI,
  //   subCategory: SubCategory.UploadThumbnail,
  //   uiSelectorType: UISelectorType.defaultSelector,
  // },
  {
    id: 'slowConnectionAfter',
    displayName: "Slow Connection After",
    category: Category.ConnectivityUI,
    subCategory: SubCategory.SlowConnectionTimeOut,
    uiSelectorType: UISelectorType.integerSelector,
  },
];

const dropdownEntries: CustomizationEntry[] = [
  {
    id: 'dropdownRootPaddingInline',
    displayName: 'Padding Left and Right',
    category: Category.Dropdown,
    subCategory: SubCategory.Layout,
    uiSelectorType: UISelectorType.defaultSelector,
    containerName: "UI"
  },


  //// MENU (SHELL)
  {
    id: 'dropdownMenuBackgroundColor',
    displayName: 'Background Color',
    category: Category.Dropdown,
    subCategory: SubCategory.DropdownMenu,
    uiSelectorType: UISelectorType.colorSelector,
    containerName: "UI"
  },
  {
    id: 'dropdownMenuPadding',
    displayName: 'Padding',
    category: Category.Dropdown,
    subCategory: SubCategory.DropdownMenu,
    uiSelectorType: UISelectorType.defaultSelector,
    containerName: "UI"
  },
  {
    id: 'dropdownMenuMarginTop',
    displayName: 'Margin Top (Offset from toggle button)',
    category: Category.Dropdown,
    subCategory: SubCategory.DropdownMenu,
    uiSelectorType: UISelectorType.defaultSelector,
    containerName: "UI"
  },
  {
    id: 'dropdownMenuMarginBottom',
    displayName: 'Margin Bottom (Offset from toggle button)',
    category: Category.Dropdown,
    subCategory: SubCategory.DropdownMenu,
    uiSelectorType: UISelectorType.defaultSelector,
    containerName: "UI"
  },
  {
    id: 'dropdownMenuBorderRadius',
    displayName: 'Border Radius',
    category: Category.Dropdown,
    subCategory: SubCategory.DropdownMenu,
    uiSelectorType: UISelectorType.defaultSelector,
    containerName: "UI"
  },
  {
    id: 'dropdownMenuBorder',
    displayName: 'Border',
    category: Category.Dropdown,
    subCategory: SubCategory.DropdownMenu,
    uiSelectorType: UISelectorType.defaultSelector,
    containerName: "UI"
  },
  {
    id: 'dropdownMenuBoxShadow',
    displayName: 'Box Shadow',
    category: Category.Dropdown,
    subCategory: SubCategory.DropdownMenu,
    uiSelectorType: UISelectorType.defaultSelector,
    containerName: "UI"
  },

  //// MENU ITEM
  {
    id: 'dropdownItemColor',
    displayName: 'Text Color',
    category: Category.Dropdown,
    subCategory: SubCategory.DropdownItem,
    uiSelectorType: UISelectorType.colorSelector,
    containerName: "UI"
  },
  {
    id: 'dropdownItemBackgroundColor',
    displayName: 'Background Color',
    category: Category.Dropdown,
    subCategory: SubCategory.DropdownItem,
    uiSelectorType: UISelectorType.colorSelector,
    containerName: "UI"
  },
  {
    id: 'dropdownItemColorOnHover',
    displayName: 'Hover Text Color',
    category: Category.Dropdown,
    subCategory: SubCategory.DropdownItem,
    uiSelectorType: UISelectorType.colorSelector,
    containerName: "UI"
  },
  {
    id: 'dropdownItemBackgroundColorOnHover',
    displayName: 'Hover Background Color',
    category: Category.Dropdown,
    subCategory: SubCategory.DropdownItem,
    uiSelectorType: UISelectorType.colorSelector,
    containerName: "UI"
  },
  {
    id: 'dropdownItemColorOnActive',
    displayName: 'Active Text Color',
    category: Category.Dropdown,
    subCategory: SubCategory.DropdownItem,
    uiSelectorType: UISelectorType.colorSelector,
    containerName: "UI"
  },
  {
    id: 'dropdownItemBackgroundColorOnActive',
    displayName: 'Active Background Color',
    category: Category.Dropdown,
    subCategory: SubCategory.DropdownItem,
    uiSelectorType: UISelectorType.colorSelector,
    containerName: "UI"
  },
  {
    id: 'dropdownItemFontSize',
    displayName: 'Font Size',
    category: Category.Dropdown,
    subCategory: SubCategory.DropdownItem,
    uiSelectorType: UISelectorType.defaultSelector,
    containerName: "UI"
  },
  {
    id: 'dropdownItemPadding',
    displayName: 'Inner Padding',
    category: Category.Dropdown,
    subCategory: SubCategory.DropdownItem,
    uiSelectorType: UISelectorType.defaultSelector,
    containerName: "UI"
  },
  {
    id: 'dropdownItemGap',
    displayName: 'Gap (icon to text)',
    category: Category.Dropdown,
    subCategory: SubCategory.DropdownItem,
    uiSelectorType: UISelectorType.defaultSelector,
    containerName: "UI"
  },
  {
    id: 'dropdownItemHeight',
    displayName: 'Height',
    category: Category.Dropdown,
    subCategory: SubCategory.DropdownItem,
    uiSelectorType: UISelectorType.defaultSelector,
    containerName: "UI"
  },
  {
    id: 'dropdownItemBorderRadius',
    displayName: 'Border Radius',
    category: Category.Dropdown,
    subCategory: SubCategory.DropdownItem,
    uiSelectorType: UISelectorType.defaultSelector,
    containerName: "UI"
  },
];

const toastUIEntries: CustomizationEntry[] = [
  {
    id: 'hideToaster',
    displayName: "Hide Toaster",
    category: Category.ToastUI,
    subCategory: SubCategory.ToasterLayout,
    uiSelectorType: UISelectorType.booleanSelector,
  },
  {
    id: 'toasterHeight',
    displayName: "Height",
    category: Category.ToastUI,
    subCategory: SubCategory.ToasterLayout,
    uiSelectorType: UISelectorType.integerSelector,
  },
  {
    id: 'toasterMaxHeight',
    displayName: "Max Height",
    category: Category.ToastUI,
    subCategory: SubCategory.ToasterLayout,
    uiSelectorType: UISelectorType.integerSelector,
  },
  // {
  //   id: 'toasterSingularMaxHeight',
  //   displayName: "Singular Max Height",
  //   category: Category.ToastUI,
  //   subCategory: SubCategory.ToasterLayout,
  //   uiSelectorType: UISelectorType.integerSelector,
  // },
  {
    id: 'toastFontSize',
    displayName: "Font Size",
    category: Category.ToastUI,
    subCategory: SubCategory.ToasterStyling,
    uiSelectorType: UISelectorType.percentageSelector,
  },
  {
    id: 'toastIconWidth',
    displayName: "Icon Width",
    category: Category.ToastUI,
    subCategory: SubCategory.ToasterStyling,
    uiSelectorType: UISelectorType.integerSelector,
  },
  {
    id: 'toastSeparatorColor',
    displayName: "Separator Color",
    category: Category.ToastUI,
    subCategory: SubCategory.ToasterStyling,
    uiSelectorType: UISelectorType.colorSelector,
  },
  {
    id: 'toastTextPadding',
    displayName: "Text Padding",
    category: Category.ToastUI,
    subCategory: SubCategory.ToasterStyling,
    uiSelectorType: UISelectorType.integerSelector,
  },
  {
    id: 'toastErrorColor',
    displayName: "Color",
    category: Category.ToastUI,
    subCategory: SubCategory.Error,
    uiSelectorType: UISelectorType.colorSelector,
  },
  {
    id: 'toastErrorBackgroundColor',
    displayName: "Background Color",
    category: Category.ToastUI,
    subCategory: SubCategory.Error,
    uiSelectorType: UISelectorType.colorSelector,
  },
  {
    id: 'toastInfoColor',
    displayName: "Color",
    category: Category.ToastUI,
    subCategory: SubCategory.Info,
    uiSelectorType: UISelectorType.colorSelector,
  },
  {
    id: 'toastInfoBackgroundColor',
    displayName: "Background Color",
    category: Category.ToastUI,
    subCategory: SubCategory.Info,
    uiSelectorType: UISelectorType.colorSelector,
  },
  {
    id: 'toastSuccessColor',
    displayName: "Color",
    category: Category.ToastUI,
    subCategory: SubCategory.Success,
    uiSelectorType: UISelectorType.colorSelector,
  },
  {
    id: 'toastSuccessBackgroundColor',
    displayName: "Background Color",
    category: Category.ToastUI,
    subCategory: SubCategory.Success,
    uiSelectorType: UISelectorType.colorSelector,
  },
  {
    id: 'toastWarnColor',
    displayName: "Color",
    category: Category.ToastUI,
    subCategory: SubCategory.Warn,
    uiSelectorType: UISelectorType.colorSelector,
  },
  {
    id: 'toastWarnBackgroundColor',
    displayName: "Background Color",
    category: Category.ToastUI,
    subCategory: SubCategory.Warn,
    uiSelectorType: UISelectorType.colorSelector,
  },
  //MM: REMOVED
  // {
  //   id: 'notificationDebounceTimeout',
  //   displayName: "Notification Debounce Timeout",
  //   category: Category.ToastUI,
  //   subCategory: SubCategory.NotificationTimeout,
  //   uiSelectorType: UISelectorType.integerSelector,
  // },
];

const miscellaneousEntries: CustomizationEntry[] = [
  {
    id: 'richCardWrapTitle',
    displayName: 'Rich Card Wrap Title',
    category: Category.Miscellaneous,
    uiSelectorType: UISelectorType.booleanSelector,
  },
  {
    id: 'disableTyping',
    displayName: 'Disable Typing',
    category: Category.Miscellaneous,
    uiSelectorType: UISelectorType.booleanSelector,
    containerName: "UI"
  },
  {
    id: 'disableTypingAnimation',
    displayName: 'Disable Typing Animation',
    category: Category.Miscellaneous,
    uiSelectorType: UISelectorType.booleanSelector,
    containerName: "UI"
  },
  {
    id: 'showTypingName',
    displayName: 'Show typing name',
    category: Category.Miscellaneous,
    uiSelectorType: UISelectorType.booleanSelector,
    containerName: "UI"
  },
  // {
  //   id: 'rootHeight',
  //   displayName: 'Root Height',
  //   category: Category.Miscellaneous,
  //   uiSelectorType: UISelectorType.percentageSelector,
  // },
  // {
  //   id: 'rootWidth',
  //   displayName: 'Root Width',
  //   category: Category.Miscellaneous,
  //   uiSelectorType: UISelectorType.percentageSelector,
  // },
  // {
  //   id: 'rootZIndex',
  //   displayName: 'Root Index',
  //   category: Category.Miscellaneous,
  //   uiSelectorType: UISelectorType.integerSelector,
  // },
  // {
  //   id: 'hideScrollToEndButton',
  //   displayName: 'Hide Scroll To End Button',
  //   category: Category.Miscellaneous,
  //   uiSelectorType: UISelectorType.booleanSelector,
  // },
  // {
  //   id: 'showSpokenText',
  //   displayName: 'Show Spoken Text',
  //   category: Category.Miscellaneous,
  //   uiSelectorType: UISelectorType.booleanSelector,
  // },
  // {
  //   id: 'videoHeight',
  //   displayName: "Video Height",
  //   category: Category.Miscellaneous,
  //   uiSelectorType: UISelectorType.integerSelector,
  // },
  // {
  //   id: 'emojiSet',
  //   displayName: "Emoji Set",
  //   category: Category.Miscellaneous,
  //   uiSelectorType: UISelectorType.defaultSelector,
  // },
  // {
  //   id: 'markdownRespectCRLF',
  //   displayName: 'Markdown Respect CRLF',
  //   category: Category.Miscellaneous,
  //   uiSelectorType: UISelectorType.booleanSelector,
  // },
];
const layoutEntries: CustomizationEntry[] = [
  // height?: Nullable<string | number>,
  //   width?: Nullable<string | number>,
  //   minWidth?: Nullable<string | number>,
  {
    id: 'autoExpandEnabled',
    displayName: 'Auto Expand',
    category: Category.Layout,
    subCategory: SubCategory.Common,
    containerName: "UI",
    uiSelectorType: UISelectorType.booleanSelector,
  },
  {
    id: 'autoExpandEnabledOnlyOnDesktop',
    displayName: 'Auto Expand on Desktop only',
    category: Category.Layout,
    subCategory: SubCategory.Common,
    containerName: "UI",
    uiSelectorType: UISelectorType.booleanSelector,
  },
  {
    id: 'closeButtonEnabled',
    displayName: 'Show default Close Button',
    category: Category.Layout,
    subCategory: SubCategory.Common,
    containerName: "UI",
    uiSelectorType: UISelectorType.booleanSelector,
  },
  {
    id: 'fullScreenMode',
    displayName: 'Fullscreen Mode',
    category: Category.Layout,
    subCategory: SubCategory.Common,
    containerName: "UI",
    uiSelectorType: UISelectorType.booleanSelector,
  }, 
  {
    id: 'showPoweredBy',
    displayName: 'Show "Powered by Druid"',
    category: Category.Layout,
    subCategory: SubCategory.Common,
    containerName: "UI",
    uiSelectorType: UISelectorType.booleanSelector,
  },
  {
    id: 'activityWrapperClassEnabled',
    displayName: 'Wrap bot activities with classes',
    category: Category.Layout,
    subCategory: SubCategory.Common,
    containerName: "UI",
    uiSelectorType: UISelectorType.booleanSelector,
  },
  {
    id: 'height',
    displayName: 'Chat Height',
    category: Category.Layout,
    subCategory: SubCategory.Common,
    containerName: "UI",
    uiSelectorType: UISelectorType.defaultSelector,
  },
  {
    id: 'width',
    displayName: 'Chat Width',
    category: Category.Layout,
    subCategory: SubCategory.Common,
    containerName: "UI",
    uiSelectorType: UISelectorType.defaultSelector,
  },
  {
    id: 'minWidth',
    displayName: 'Chat Minimum Width',
    category: Category.Layout,
    subCategory: SubCategory.Common,
    containerName: "UI",
    uiSelectorType: UISelectorType.defaultSelector,
  },
  {
    id: 'position',
    displayName: 'Position (left/right)',
    category: Category.Layout,
    subCategory: SubCategory.Common,
    containerName: "UI",
    uiSelectorType: UISelectorType.dropDownSelector,
  },
  {
    id: 'floatRight',
    displayName: 'Float',
    category: Category.Layout,
    subCategory: SubCategory.Common,
    containerName: "UI",
    uiSelectorType: UISelectorType.defaultSelector,
  },
  {
    id: 'bottom',
    displayName: 'Bottom',
    category: Category.Layout,
    subCategory: SubCategory.Common,
    containerName: "UI",
    uiSelectorType: UISelectorType.defaultSelector,
  },
  {
    id: 'top',
    displayName: 'Top',
    category: Category.Layout,
    subCategory: SubCategory.Common,
    containerName: "UI",
    uiSelectorType: UISelectorType.defaultSelector,
  },
  //// CHAT BOX
  {
    id: 'chatBoxBorderRadius',
    displayName: 'Border Radius',
    category: Category.Layout,
    subCategory: SubCategory.ChatBox,
    containerName: "UI",
    uiSelectorType: UISelectorType.integerSelector,
  },
  {
    id: 'chatBoxBottomRadius',
    displayName: 'Bottom Radius',
    category: Category.Layout,
    subCategory: SubCategory.ChatBox,
    containerName: "UI",
    uiSelectorType: UISelectorType.integerSelector,
  },
  {
    id: 'chatBoxBorderColor',
    displayName: 'Border Color',
    category: Category.Layout,
    subCategory: SubCategory.ChatBox,
    containerName: "UI",
    uiSelectorType: UISelectorType.colorSelector,
  },
  {
    id: 'transcriptLinkColor',
    displayName: 'Link Color',
    category: Category.Layout,
    subCategory: SubCategory.ChatBox,
    containerName: "UI",
    uiSelectorType: UISelectorType.colorSelector,
  },
  {
    id: 'chatBoxBorderSize',
    displayName: 'Border Size',
    category: Category.Layout,
    subCategory: SubCategory.ChatBox,
    containerName: "UI",
    uiSelectorType: UISelectorType.integerSelector,
  },
  {
    id: 'resizableEnabled',
    displayName: 'Enable Resize',
    category: Category.Layout,
    subCategory: SubCategory.ChatBox,
    containerName: "UI",
    uiSelectorType: UISelectorType.booleanSelector,
  },
  {
    id: 'autoScrollSnapOnPage',
    displayName: 'Auto Scroll',
    category: Category.Layout,
    subCategory: SubCategory.ChatBox,
    uiSelectorType: UISelectorType.booleanSelector,
  },
  //// HEADER
  {
    id: 'chatTitle',
    displayName: 'Chat Title',
    category: Category.Layout,
    subCategory: SubCategory.Header,
    uiSelectorType: UISelectorType.defaultSelector,
    containerName: "UI"
  },
  {
    id: 'chatDescription',
    displayName: 'Chat Description',
    category: Category.Layout,
    subCategory: SubCategory.Header,
    uiSelectorType: UISelectorType.defaultSelector,
    containerName: "UI"
  },
  {
    id: 'headerCustomIconEnabled',
    displayName: 'Enable Custom Icon',
    category: Category.Layout,
    subCategory: SubCategory.Header,
    uiSelectorType: UISelectorType.booleanSelector,
    containerName: "UI"
  },
  {
    id: 'headerTextColor',
    displayName: 'Text Color',
    category: Category.Layout,
    subCategory: SubCategory.Header,
    containerName: "UI",
    uiSelectorType: UISelectorType.colorSelector,
  },
  {
    id: 'headerDescriptionTextColor',
    displayName: 'Description Text Color',
    category: Category.Layout,
    subCategory: SubCategory.Header,
    containerName: "UI",
    uiSelectorType: UISelectorType.colorSelector,
  },
  {
    id: 'headerTextColorOnHover',
    displayName: 'Hover Text Color',
    category: Category.Layout,
    subCategory: SubCategory.Header,
    containerName: "UI",
    uiSelectorType: UISelectorType.colorSelector,
  },
  // {
  //   id: 'headerFontSize',
  //   displayName: 'Font Size',
  //   category: Category.Layout,
  //   subCategory: SubCategory.Header,
  //   containerName: "UI",
  //   uiSelectorType: UISelectorType.defaultSelector,
  // },
  {
    id: 'headerTopBorderRadius',
    displayName: 'Top Border Radius',
    category: Category.Layout,
    subCategory: SubCategory.Header,
    containerName: "UI",
    uiSelectorType: UISelectorType.defaultSelector,
    hidden: ['!UI.druidNewLayoutEnabled']
  },
  {
    id: 'headerBottomBorderRadius',
    displayName: 'Bottom Border Radius',
    category: Category.Layout,
    subCategory: SubCategory.Header,
    containerName: "UI",
    uiSelectorType: UISelectorType.defaultSelector,
    hidden: ['!UI.druidNewLayoutEnabled']
  },
  {
    id: 'headerBorderRadius',
    displayName: 'Border Radius',
    category: Category.Layout,
    subCategory: SubCategory.Header,
    containerName: "UI",
    uiSelectorType: UISelectorType.defaultSelector,
    hidden: ['UI.restylingsEnabled']
  },
  {
    id: 'headerBorderColor',
    displayName: 'Border Color',
    category: Category.Layout,
    subCategory: SubCategory.Header,
    containerName: "UI",
    uiSelectorType: UISelectorType.colorSelector,
    hidden: ['UI.restylingsEnabled']
  },
  {
    id: 'headerBorderSizeTop',
    displayName: 'Border Size Top',
    category: Category.Layout,
    subCategory: SubCategory.Header,
    containerName: "UI",
    uiSelectorType: UISelectorType.integerSelector,
    hidden: ['UI.restylingsEnabled']
  },
  {
    id: 'headerBorderSizeBottom',
    displayName: 'Border Size Bottom',
    category: Category.Layout,
    subCategory: SubCategory.Header,
    containerName: "UI",
    uiSelectorType: UISelectorType.integerSelector,
    hidden: ['UI.restylingsEnabled']
  },
  {
    id: 'headerBorderSizeLeft',
    displayName: 'Border Size Left',
    category: Category.Layout,
    subCategory: SubCategory.Header,
    containerName: "UI",
    uiSelectorType: UISelectorType.integerSelector,
    hidden: ['UI.restylingsEnabled']
  },
  {
    id: 'headerBorderSizeRight',
    displayName: 'Border Size Right',
    category: Category.Layout,
    subCategory: SubCategory.Header,
    containerName: "UI",
    uiSelectorType: UISelectorType.integerSelector,
    hidden: ['UI.restylingsEnabled']
  },
  {
    id: 'headerActionsGap',
    displayName: 'Actions Gap',
    category: Category.Layout,
    subCategory: SubCategory.Header,
    containerName: "UI",
    uiSelectorType: UISelectorType.defaultSelector,
  },
  //obsolete, use header{Outer/Inner}Padding{LeftRight/TopBottom} instead
  {
    id: 'headerOuterPadding',
    displayName: 'Outer Padding',
    category: Category.Layout,
    subCategory: SubCategory.Header,
    containerName: "UI",
    uiSelectorType: UISelectorType.integerSelector,
    hidden: true
  },
  {
    id: 'headerInnerPadding',
    displayName: 'Inner Padding',
    category: Category.Layout,
    subCategory: SubCategory.Header,
    containerName: "UI",
    uiSelectorType: UISelectorType.integerSelector,
    hidden: true
  },
  {
    id: 'headerOuterPaddingLeftRight',
    displayName: 'Outer Padding Left/Right',
    category: Category.Layout,
    subCategory: SubCategory.Header,
    containerName: "UI",
    uiSelectorType: UISelectorType.integerSelector,
  },
  {
    id: 'headerOuterPaddingTopBottom',
    displayName: 'Outer Padding Top/Bottom',
    category: Category.Layout,
    subCategory: SubCategory.Header,
    containerName: "UI",
    uiSelectorType: UISelectorType.integerSelector,
  },
  {
    id: 'headerInnerPaddingLeftRight',
    displayName: 'Inner Padding Left/Right',
    category: Category.Layout,
    subCategory: SubCategory.Header,
    containerName: "UI",
    uiSelectorType: UISelectorType.integerSelector,
  },
  {
    id: 'headerInnerPaddingTopBottom',
    displayName: 'Inner Padding Top/Bottom',
    category: Category.Layout,
    subCategory: SubCategory.Header,
    containerName: "UI",
    uiSelectorType: UISelectorType.integerSelector,
  },
  {
    id: 'headerBackground',
    displayName: 'Background Color',
    category: Category.Layout,
    subCategory: SubCategory.Header,
    containerName: "UI",
    uiSelectorType: UISelectorType.colorSelector,
  },

  {
    id: 'headerButtonColor',
    displayName: 'Color',
    category: Category.Layout,
    subCategory: SubCategory.HeaderButtons,
    containerName: "UI",
    uiSelectorType: UISelectorType.colorSelector,
  },
  {
    id: 'headerButtonColorOnHover',
    displayName: 'Color On Hover',
    category: Category.Layout,
    subCategory: SubCategory.HeaderButtons,
    containerName: "UI",
    uiSelectorType: UISelectorType.colorSelector,
  },
  {
    id: 'headerButtonColorOnFocus',
    displayName: 'Color On Focus',
    category: Category.Layout,
    subCategory: SubCategory.HeaderButtons,
    containerName: "UI",
    uiSelectorType: UISelectorType.colorSelector,
  },
  {
    id: 'headerButtonColorOnDisabled',
    displayName: 'Color On Disabled',
    category: Category.Layout,
    subCategory: SubCategory.HeaderButtons,
    containerName: "UI",
    uiSelectorType: UISelectorType.colorSelector,
  },
  {
    id: 'headerButtonBackgroundColor',
    displayName: 'Background Color',
    category: Category.Layout,
    subCategory: SubCategory.HeaderButtons,
    containerName: "UI",
    uiSelectorType: UISelectorType.colorSelector,
  },
  {
    id: 'headerButtonBackgroundColorOnHover',
    displayName: 'Background Color On Hover',
    category: Category.Layout,
    subCategory: SubCategory.HeaderButtons,
    containerName: "UI",
    uiSelectorType: UISelectorType.colorSelector,
  },
  {
    id: 'headerButtonBackgroundColorOnFocus',
    displayName: 'Background Color On Focus',
    category: Category.Layout,
    subCategory: SubCategory.HeaderButtons,
    containerName: "UI",
    uiSelectorType: UISelectorType.colorSelector,
  },
  {
    id: 'headerButtonPadding',
    displayName: 'Padding',
    category: Category.Layout,
    subCategory: SubCategory.HeaderButtons,
    containerName: "UI",
    uiSelectorType: UISelectorType.defaultSelector,
  },
  {
    id: 'headerButtonBorder',
    displayName: 'Border',
    category: Category.Layout,
    subCategory: SubCategory.HeaderButtons,
    containerName: "UI",
    uiSelectorType: UISelectorType.defaultSelector,
  },
  {
    id: 'headerButtonBorderRadius',
    displayName: 'Border Radius',
    category: Category.Layout,
    subCategory: SubCategory.HeaderButtons,
    containerName: "UI",
    uiSelectorType: UISelectorType.defaultSelector,
  },
  {
    id: 'headerButtonDisabledOpacity',
    displayName: 'Disabled Opacity',
    category: Category.Layout,
    subCategory: SubCategory.HeaderButtons,
    containerName: "UI",
    uiSelectorType: UISelectorType.defaultSelector,
  },
  {
    id: 'headerButtonTransform',
    displayName: 'Transform (ex: scale(1.3))',
    category: Category.Layout,
    subCategory: SubCategory.HeaderButtons,
    containerName: "UI",
    uiSelectorType: UISelectorType.defaultSelector,
  },
  {
    id: 'headerLanguageSelectorScale',
    displayName: 'Language Selector Scale',
    category: Category.Layout,
    subCategory: SubCategory.HeaderButtons,
    containerName: "UI",
    uiSelectorType: UISelectorType.defaultSelector,
  },

  {
    id: 'showCloseButton',
    displayName: 'Show Close Button',
    category: Category.Layout,
    subCategory: SubCategory.Header,
    containerName: "UI.headerOptions",
    uiSelectorType: UISelectorType.booleanSelector,
  },
  {
    id: 'showChangeSideButton',
    displayName: 'Show Change Side Button',
    category: Category.Layout,
    subCategory: SubCategory.Header,
    containerName: "UI.headerOptions",
    uiSelectorType: UISelectorType.booleanSelector,
  },
  {
    id: 'showLanguageSelector',
    displayName: 'Show Language Selector Button',
    category: Category.Layout,
    subCategory: SubCategory.Header,
    containerName: "UI.headerOptions",
    uiSelectorType: UISelectorType.booleanSelector,
  },
  {
    id: 'showAvatar',
    displayName: 'Header - Show Avatar',
    category: Category.Layout,
    subCategory: SubCategory.Header,
    containerName: "UI.headerOptions",
    uiSelectorType: UISelectorType.booleanSelector,
  },
  {
    id: 'headerAvatarBorderRadius',
    displayName: 'Avatar Border Radius',
    category: Category.Layout,
    subCategory: SubCategory.Header,
    containerName: "UI",
    uiSelectorType: UISelectorType.percentageSelector,
    hidden: ['UI.headerOptions.showAvatar'],
  },
  {
    id: 'showVoiceInputSelector',
    displayName: 'Show Voice Input Selector',
    category: Category.Layout,
    subCategory: SubCategory.Header,
    containerName: "UI.headerOptions",
    uiSelectorType: UISelectorType.booleanSelector,
  },
  {
    id: 'showReload',
    displayName: 'Header - Show Reload Button',
    category: Category.Layout,
    subCategory: SubCategory.Header,
    containerName: "UI.headerOptions",
    uiSelectorType: UISelectorType.booleanSelector,
  },
  {
    id: 'showReset',
    displayName: 'Header - Show Reset Button',
    category: Category.Layout,
    subCategory: SubCategory.Header,
    containerName: "UI.headerOptions",
    uiSelectorType: UISelectorType.booleanSelector,
  },
];
const customCSSEntries: CustomizationEntry[] = [
  {
      id: 'customDruidStyleSet',
      displayName: 'Druid StyleSet - JSON',
      category: Category.CustomCSS,
      containerName: "root",
      uiSelectorType: UISelectorType.defaultSelector,
      multiline: true,
      defaultValue: 
`
{
  "webchatRoot": {
    "#druidWebchatRoot_v2 &": {
      ".druid__minimizable__web-chat__default-container-element": {
          "background-color": "#70b244",
          "border-color": "#70b244"
      }
    }
  }
}
`.trim()
  },
  {
    id: 'restylingsEnabled',
    displayName: 'Druid New Layout v1',
    category: Category.CustomCSS,
    containerName: "UI",
    uiSelectorType: UISelectorType.booleanSelector,
  },
    {
    id: 'druidNewLayoutEnabled',
    displayName: 'Druid New Layout v2',
    category: Category.CustomCSS,
    containerName: "UI",
    uiSelectorType: UISelectorType.booleanSelector,
  }
]

const customHandlers: CustomizationEntry[] = [
  {
    id: 'webChatEventHandler',
    displayName: 'Webchat Event Handlers',
    category: Category.Handlers,
    uiSelectorType: UISelectorType.reactSelector,
    containerName: "root",
    multiline: true,
    defaultValue: 
    `(action, currentDruidState) => {
      if (action.type === 'DIRECT_LINE/INCOMING_ACTIVITY' && DruidWebchat_v2.isNewActivity(currentDruidState, action.payload.activity)) {
        if(action.payload.activity.type === "event" && action.payload.activity.name == "disableEvent") {
          DruidWebchat_v2.disableChat();
        }
      }
    }`
  },
  {
    id: 'activityStatusMiddleware',
    displayName: 'ActivityStatus Middleware',
    category: Category.Handlers,
    uiSelectorType: UISelectorType.reactSelector,
    containerName: "middlewares",
    multiline: true,
    defaultValue: "({ dispatch }) => next => (args) => next(args)"
  },
  {
    id: 'cardActionMiddleware',
    displayName: 'CardAction Middleware',
    category: Category.Handlers,
    uiSelectorType: UISelectorType.reactSelector,
    containerName: "middlewares",
    multiline: true,
    defaultValue: `({ dispatch }) => next => (args) => {
      const { cardAction} = args;
      console.log(\`clicked \${cardAction.value}\`);
      return next(args);
    }`
  },
  {
    id: 'attachmentMiddleware',
    displayName: 'Attachment Middleware',
    category: Category.Handlers,
    uiSelectorType: UISelectorType.reactSelector,
    containerName: "middlewares",
    multiline: true,
    defaultValue: "({ dispatch }) => next => (args) => next(args)"

  },
  {
    id: 'activityMiddleware',
    displayName: 'Activity Middleware',
    category: Category.Handlers,
    uiSelectorType: UISelectorType.reactSelector,
    containerName: "middlewares",
    multiline: true,
    defaultValue: ` () => next => (...setupArgs) => {
      const [card] = setupArgs;
      const activity = card.activity;
      if ( activity.type == 'message' && activity.text) {
        return (...renderArgs) => (
          (<>
            {
              next(card)(...renderArgs)
            }
          </>)
        );
      }
      return next(...setupArgs);
    }`

  },
  {
    id: 'scrollToEndButtonMiddleware',
    displayName: 'ScrollToEnd Button Middleware',
    category: Category.Handlers,
    uiSelectorType: UISelectorType.reactSelector,
    containerName: "root",
    multiline: true,
    defaultValue: `() => (next) => (args)=> (props) => {
      const nextRender = next(args);
      return nextRender ? <>{next(args)(props)}</> : <></>;
    }`
  }
];

const generalEntries: CustomizationEntry[] = [
  {
    id: 'isDisabled',
    displayName: 'Disable webchat',
    category: Category.General,
    subCategory: SubCategory.Common,
    uiSelectorType: UISelectorType.booleanSelector,
    containerName: "root"
  },
  {
    id: 'queryParams',
    displayName: 'queryParams',
    category: Category.General,
    subCategory: SubCategory.Common,
    uiSelectorType: UISelectorType.defaultSelector,
    containerName: "root"
  },
  {
    id: 'backgroundTrafficEnabled',
    displayName: 'Background Traffic Enabled',
    category: Category.General,
    subCategory: SubCategory.Common,
    uiSelectorType: UISelectorType.booleanSelector,
    containerName: "root"
  },
  {
    id: 'authorizationUrl',
    displayName: 'authorizationUrl',
    category: Category.General,
    subCategory: SubCategory.Common,
    uiSelectorType: UISelectorType.defaultSelector,
    containerName: "root"
  },
  {
    id: 'authorizationBaseUrl',
    displayName: 'authorizationBaseUrl',
    category: Category.General,
    subCategory: SubCategory.Common,
    uiSelectorType: UISelectorType.defaultSelector,
    containerName: "root"
  },
  {
    id: 'withCredentials',
    displayName: 'Calls withCredentials',
    category: Category.General,
    subCategory: SubCategory.Common,
    uiSelectorType: UISelectorType.booleanSelector,
    containerName: "root"
  },
  {
    id: 'withCredentials_authorization',
    displayName: 'Authorization call withCredentials',
    category: Category.General,
    subCategory: SubCategory.Common,
    uiSelectorType: UISelectorType.booleanSelector,
    containerName: "root"
  },
  {
    id: 'notificationsEnabled',
    displayName: 'Enable Notifications',
    category: Category.General,
    subCategory: SubCategory.Common,
    uiSelectorType: UISelectorType.booleanSelector,
    containerName: "root"
  },
  {
    id: 'otherServicesEndpointIndex',
    displayName: 'Other Services Endpoint Index',
    category: Category.General,
    subCategory: SubCategory.Common,
    uiSelectorType: UISelectorType.integerSelector,
    containerName: "root"
  },
  {
    id: 'heartBeatUrl',
    displayName: '\'Heartbeat\' Url',
    category: Category.General,
    subCategory: SubCategory.Common,
    uiSelectorType: UISelectorType.defaultSelector,
    containerName: "root"
  },
  {
    id: 'applyWebchatCustomizationsOnMultichat',
    displayName: 'Apply Webchat Customizations on Multichat',
    category: Category.General,
    subCategory: SubCategory.Common,
    uiSelectorType: UISelectorType.booleanSelector,
    containerName: "root"
  },
  // {
  //   id: 'userId',
  //   displayName: 'userId',
  //   category: Category.General,
  //   uiSelectorType: UISelectorType.defaultSelector,
  //   containerName: "root"
  // },
  // {
  //   id: 'username',
  //   displayName: 'username',
  //   category: Category.General,
  //   uiSelectorType: UISelectorType.defaultSelector,
  //   containerName: "root"
  // },
  //// COOKIES
 
  {
    id: 'conversationTokenEnabled',
    displayName: 'conversationTokenEnabled',
    category: Category.General,
    subCategory: SubCategory.Cookies,
    uiSelectorType: UISelectorType.booleanSelector,
    containerName: "root"
  },
  {
    id: 'druidCookiesExpirationInDays',
    displayName: 'druidCookiesExpirationInDays - Can be fractional (ex: 1/48 for 30minutes)',
    category: Category.General,
    subCategory: SubCategory.Cookies,
    uiSelectorType: UISelectorType.defaultSelector,
    containerName: "root"
  },
  {
    id: 'conversationToken_namePrefix',
    displayName: 'conversationToken_namePrefix',
    category: Category.General,
    subCategory: SubCategory.Cookies,
    uiSelectorType: UISelectorType.defaultSelector,
    containerName: "root"
  },
  {
    id: 'druidWebChatIsOpenedEnabled',
    displayName: 'druidWebChatIsOpenedEnabled',
    category: Category.General,
    subCategory: SubCategory.Cookies,
    uiSelectorType: UISelectorType.booleanSelector,
    containerName: "root"
  },
  {
    id: 'druidWebChatIsOpened_namePrefix',
    displayName: 'druidWebChatIsOpened_namePrefix',
    category: Category.General,
    subCategory: SubCategory.Cookies,
    uiSelectorType: UISelectorType.defaultSelector,
    containerName: "root"
  },
  {
    id: 'druidCookieConsentEnabled',
    displayName: 'druidCookieConsent',
    category: Category.General,
    subCategory: SubCategory.Cookies,
    uiSelectorType: UISelectorType.booleanSelector,
    containerName: "root"
  },
  {
    id: 'cookieDomain',
    displayName: 'cookieDomain',
    category: Category.General,
    subCategory: SubCategory.Cookies,
    uiSelectorType: UISelectorType.defaultSelector,
    containerName: "root"
  },
];

const heroCardEntries: CustomizationEntry[] = [
  {
    id: 'enableHeroCardAvatar',
    displayName: 'Enable Avatar',
    category: Category.HeroCard,
    subCategory: SubCategory.Common,
    uiSelectorType: UISelectorType.booleanSelector,
    containerName: "UI"
  },
  {
    id: 'heroCardBorderRadius',
    displayName: 'Border Radius',
    category: Category.HeroCard,
    subCategory: SubCategory.Common,
    uiSelectorType: UISelectorType.integerSelector,
    containerName: "UI"
  },
  {
    id: 'heroCardBorderColor',
    displayName: 'Border Color',
    category: Category.HeroCard,
    subCategory: SubCategory.Common,
    uiSelectorType: UISelectorType.colorSelector,
    containerName: "UI"
  },
  {
    id: 'heroCardBorderSize',
    displayName: 'Border Size',
    category: Category.HeroCard,
    subCategory: SubCategory.Common,
    uiSelectorType: UISelectorType.integerSelector,
    containerName: "UI"
  },
  {
    id: 'heroCardInnerPadding',
    displayName: 'Inner Padding',
    category: Category.HeroCard,
    subCategory: SubCategory.Common,
    uiSelectorType: UISelectorType.integerSelector,
    containerName: "UI"
  },
  {
    id: 'heroCardTitleTextSize',
    displayName: 'Title Text Size',
    category: Category.HeroCard,
    subCategory: SubCategory.Common,
    uiSelectorType: UISelectorType.integerSelector,
    containerName: "UI"
  },
  {
    id: 'heroCardTitleTextColor',
    displayName: 'Title Text Color',
    category: Category.HeroCard,
    subCategory: SubCategory.Common,
    uiSelectorType: UISelectorType.colorSelector,
    containerName: "UI"
  },
  {
    id: 'heroCardDescriptionTextColor',
    displayName: 'Description Text Color',
    category: Category.HeroCard,
    subCategory: SubCategory.Common,
    uiSelectorType: UISelectorType.colorSelector,
    containerName: "UI"
  },
  {
    id: 'heroCardButtonsBorderColor',
    displayName: 'Buttons Border Color',
    category: Category.HeroCard,
    subCategory: SubCategory.ButtonColors,
    uiSelectorType: UISelectorType.colorSelector,
    containerName: "UI"
  },
  {
    id: 'heroCardButtonsBorderSize',
    displayName: 'Buttons Border Size',
    category: Category.HeroCard,
    subCategory: SubCategory.ButtonColors,
    uiSelectorType: UISelectorType.integerSelector,
    containerName: "UI"
  },
  {
    id: 'heroCardButtonsColor',
    displayName: 'Buttons Color',
    category: Category.HeroCard,
    subCategory: SubCategory.ButtonColors,
    uiSelectorType: UISelectorType.colorSelector,
    containerName: "UI"
  },
  {
    id: 'heroCardButtonsColorOnFocus',
    displayName: 'Buttons Color On Focus',
    category: Category.HeroCard,
    subCategory: SubCategory.ButtonColors,
    uiSelectorType: UISelectorType.colorSelector,
    containerName: "UI"
  },
  {
    id: 'heroCardButtonsColorOnHover',
    displayName: 'Buttons Color On Hover',
    category: Category.HeroCard,
    subCategory: SubCategory.ButtonColors,
    uiSelectorType: UISelectorType.colorSelector,
    containerName: "UI"
  },
  {
    id: 'heroCardButtonsTextColor',
    displayName: 'Buttons Text Color',
    category: Category.HeroCard,
    subCategory: SubCategory.ButtonColors,
    uiSelectorType: UISelectorType.colorSelector,
    containerName: "UI"
  },
  {
    id: 'heroCardButtonsTextColorOnFocus',
    displayName: 'Buttons Text Color On Focus',
    category: Category.HeroCard,
    subCategory: SubCategory.ButtonColors,
    uiSelectorType: UISelectorType.colorSelector,
    containerName: "UI"
  },
  {
    id: 'heroCardButtonsTextColorOnHover',
    displayName: 'Buttons Text Color On Hover',
    category: Category.HeroCard,
    subCategory: SubCategory.ButtonColors,
    uiSelectorType: UISelectorType.colorSelector,
    containerName: "UI"
  }
]

const reasoningMessageEntries: CustomizationEntry[] = [
  {
    id: 'reasoningCardAccentColor',
    displayName: 'Accent Color',
    category: Category.ReasoningMessage,
    subCategory: SubCategory.Common,
    uiSelectorType: UISelectorType.colorSelector,
    containerName: "UI"
  },
  {
    id: 'reasoningCardBackgroundColor',
    displayName: 'Background Color',
    category: Category.ReasoningMessage,
    subCategory: SubCategory.Common,
    uiSelectorType: UISelectorType.colorSelector,
    containerName: "UI"
  },
  {
    id: 'reasoningCardBorderRadius',
    displayName: 'Border Radius',
    category: Category.ReasoningMessage,
    subCategory: SubCategory.Common,
    uiSelectorType: UISelectorType.defaultSelector,
    containerName: "UI"
  },
  {
    id: 'reasoningCardTextColor',
    displayName: 'Text Color',
    category: Category.ReasoningMessage,
    subCategory: SubCategory.Common,
    uiSelectorType: UISelectorType.colorSelector,
    containerName: "UI"
  },
  {
    id: 'reasoningCardSecondaryTextColor',
    displayName: 'Secondary Text Color',
    category: Category.ReasoningMessage,
    subCategory: SubCategory.Common,
    uiSelectorType: UISelectorType.colorSelector,
    containerName: "UI"
  },
  {
    id: 'reasoningCardBorderColor',
    displayName: 'Border Color',
    category: Category.ReasoningMessage,
    subCategory: SubCategory.Common,
    uiSelectorType: UISelectorType.colorSelector,
    containerName: "UI"
  },
];

const greetingsMessageEntries: CustomizationEntry[] = [
  {
    id: 'hideWelcomeMessageAfterUserInput',
    displayName: 'Hide Welcome Message After User Input',
    category: Category.GreetingsMessage,
    subCategory: SubCategory.Common,
    uiSelectorType: UISelectorType.booleanSelector,
    containerName: "UI"
  },
    {
    id: 'alignSendboxInCenter',
    displayName: 'Align Send Box in Center with Greeting Message (Only Fullscreen Mode)',
    category: Category.GreetingsMessage,
    subCategory: SubCategory.Common,
    uiSelectorType: UISelectorType.booleanSelector,
    containerName: "UI"
  },
  {
    id: 'greetingMessageColor',
    displayName: 'Text Color (or Gradient)',
    category: Category.GreetingsMessage,
    subCategory: SubCategory.Common,
    uiSelectorType: UISelectorType.defaultSelector,
    containerName: "UI"
  },
  {
    id: 'greetingMessageBackground',
    displayName: 'Background',
    category: Category.GreetingsMessage,
    subCategory: SubCategory.Common,
    uiSelectorType: UISelectorType.defaultSelector,
    containerName: "UI"
  },
  {
    id: 'greetingMessageBorderRadius',
    displayName: 'Border Radius',
    category: Category.GreetingsMessage,
    subCategory: SubCategory.Common,
    uiSelectorType: UISelectorType.defaultSelector,
    containerName: "UI"
  },
  {
    id: 'greetingMessagePadding',
    displayName: 'Padding',
    category: Category.GreetingsMessage,
    subCategory: SubCategory.Common,
    uiSelectorType: UISelectorType.defaultSelector,
    containerName: "UI"
  },
  {
    id: 'greetingMessageMargin',
    displayName: 'Margin',
    category: Category.GreetingsMessage,
    subCategory: SubCategory.Common,
    uiSelectorType: UISelectorType.defaultSelector,
    containerName: "UI"
  },
  {
    id: 'greetingMessageFontSize',
    displayName: 'Font Size',
    category: Category.GreetingsMessage,
    subCategory: SubCategory.Common,
    uiSelectorType: UISelectorType.defaultSelector,
    containerName: "UI"
  },
  {
    id: 'greetingMessageFontWeight',
    displayName: 'Font Weight',
    category: Category.GreetingsMessage,
    subCategory: SubCategory.Common,
    uiSelectorType: UISelectorType.defaultSelector,
    containerName: "UI"
  },
  {
    id: 'greetingMessageAnimation',
    displayName: 'Animation',
    category: Category.GreetingsMessage,
    subCategory: SubCategory.Common,
    uiSelectorType: UISelectorType.dropDownSelector,
    containerName: "UI"
  },
  {
    id: 'greetingMessageIcon',
    displayName: 'Icon',
    category: Category.GreetingsMessage,
    subCategory: SubCategory.Icons,
    uiSelectorType: UISelectorType.defaultSelector,
    multiline: true,
    containerName: "UI"
  },
];

const informativeMessageEntries: CustomizationEntry[] = [
  {
    id: 'informativeMessageColor',
    displayName: 'Text Color (or Gradient)',
    category: Category.InformativeMessage,
    subCategory: SubCategory.Common,
    uiSelectorType: UISelectorType.defaultSelector,
    containerName: "UI"
  },
  {
    id: 'informativeMessageBackground',
    displayName: 'Background',
    category: Category.InformativeMessage,
    subCategory: SubCategory.Common,
    uiSelectorType: UISelectorType.defaultSelector,
    containerName: "UI"
  },
  {
    id: 'informativeMessageBorderRadius',
    displayName: 'Border Radius',
    category: Category.InformativeMessage,
    subCategory: SubCategory.Common,
    uiSelectorType: UISelectorType.defaultSelector,
    containerName: "UI"
  },
  {
    id: 'informativeMessagePadding',
    displayName: 'Padding',
    category: Category.InformativeMessage,
    subCategory: SubCategory.Common,
    uiSelectorType: UISelectorType.defaultSelector,
    containerName: "UI"
  },
  {
    id: 'informativeMessageMargin',
    displayName: 'Margin',
    category: Category.InformativeMessage,
    subCategory: SubCategory.Common,
    uiSelectorType: UISelectorType.defaultSelector,
    containerName: "UI"
  },
  {
    id: 'informativeMessageFontSize',
    displayName: 'Font Size',
    category: Category.InformativeMessage,
    subCategory: SubCategory.Common,
    uiSelectorType: UISelectorType.defaultSelector,
    containerName: "UI"
  },
  {
    id: 'informativeMessageFontWeight',
    displayName: 'Font Weight',
    category: Category.InformativeMessage,
    subCategory: SubCategory.Common,
    uiSelectorType: UISelectorType.defaultSelector,
    containerName: "UI"
  },
  {
    id: 'informativeMessageIcon',
    displayName: 'Icon',
    category: Category.InformativeMessage,
    subCategory: SubCategory.Icons,
    uiSelectorType: UISelectorType.defaultSelector,
    multiline: true,
    containerName: "UI"
  },
];

const localizationEntry: CustomizationEntry = {
  id: 'localization',
  displayName: 'Localization',
  category: Category.Localization,
  uiSelectorType: UISelectorType.localizationSelector,
  containerName: "root"
};

const launcherEntry: CustomizationEntry[] = [
  {
    id: 'launcherBackgroundColor',
    displayName: 'Launcher Background Color (Rgb or Hex)',
    category: Category.Launcher,
    uiSelectorType: UISelectorType.defaultSelector,
    containerName: "UI"
  },
  {
    id: 'launcherBackgroundColorHover',
    displayName: 'Launcher Background Color On Hover (Rgb or Hex)',
    category: Category.Launcher,
    uiSelectorType: UISelectorType.defaultSelector,
    containerName: "UI"
  },
  {
    id: 'launcherIconColor',
    displayName: 'Launcher Icon Color (Rgb or Hex)',
    category: Category.Launcher,
    uiSelectorType: UISelectorType.defaultSelector,
    containerName: "UI"
  },
  {
    id: 'launcherIconColorOnHover',
    displayName: 'Launcher Icon Color On Hover (Rgb or Hex)',
    category: Category.Launcher,
    uiSelectorType: UISelectorType.defaultSelector,
    containerName: "UI"
  }
]


const dropzoneEntries: CustomizationEntry[] = [
  {
    id: 'dropzonePrimaryColor',
    displayName: 'Primary Color (Border & Icon)',
    category: Category.Dropzone,
    subCategory: SubCategory.Colors,
    uiSelectorType: UISelectorType.colorSelector,
    containerName: "UI"
  },
  {
    id: 'dropzoneSecondaryColor',
    displayName: 'Secondary Color (Background)',
    category: Category.Dropzone,
    subCategory: SubCategory.Colors,
    uiSelectorType: UISelectorType.colorSelector,
    containerName: "UI"
  },
  {
    id: 'dropzoneBackgroundOpacity',
    displayName: 'Background Opacity',
    category: Category.Dropzone,
    subCategory: SubCategory.Colors,
    uiSelectorType: UISelectorType.percentageSelector,
    containerName: "UI"
  },
  {
    id: 'dropzoneTextColor',
    displayName: 'Text Color',
    category: Category.Dropzone,
    subCategory: SubCategory.Colors,
    uiSelectorType: UISelectorType.colorSelector,
    containerName: "UI"
  },
  {
    id: 'dropzoneBorderWidth',
    displayName: 'Border Width',
    category: Category.Dropzone,
    subCategory: SubCategory.Border,
    uiSelectorType: UISelectorType.integerSelector,
    containerName: "UI"
  },
  {
    id: 'dropzoneBlur',
    displayName: 'Background Blur',
    category: Category.Dropzone,
    subCategory: SubCategory.Layout,
    uiSelectorType: UISelectorType.integerSelector,
    containerName: "UI"
  },
  {
    id: 'dropzoneIconSize',
    displayName: 'Icon Size',
    category: Category.Dropzone,
    subCategory: SubCategory.Layout,
    uiSelectorType: UISelectorType.integerSelector,
    containerName: "UI"
  },
  {
    id: 'dropzoneTextSize',
    displayName: 'Text Size',
    category: Category.Dropzone,
    subCategory: SubCategory.Layout,
    uiSelectorType: UISelectorType.integerSelector,
    containerName: "UI"
  },
];

const searchEntry: CustomizationEntry = {
  id: 'search',
  displayName: 'Search',
  category: Category.Search,
  uiSelectorType: UISelectorType.searchSelector,
  containerName: "root"
};

const themesEntry: CustomizationEntry = {
  id: 'themes',
  displayName: 'Themes',
  category: Category.Themes,
  uiSelectorType: UISelectorType.themeSelector,
  containerName: "UI"
};

const voiceEntries: CustomizationEntry[] = [
  {
  id: 'Speech_SegmentationSilenceTimeoutMs',
  displayName: 'Silence Timeout Ms',
  category: Category.Voice,
  uiSelectorType: UISelectorType.integerSelector,
  containerName: "UI"
  },
  {
    id: 'showVoiceChatSwitch',
    displayName: 'Show Voice Chat Switch',
    category: Category.Voice,
    uiSelectorType: UISelectorType.booleanSelector,
    containerName: "UI"
  }
];
export const customizationEntries: CustomizationEntry[] = [
  ...colorAndPaddingEntries,
  ...fontEntries,
  ...avatarEntries,
  ...buttonsEntries,
  ...chatBubbleEntries,
  ...sendBoxEntries,
  ...dropzoneEntries,
  ...dropdownEntries,
  ...suggestedActionsEntries,
  ...timestampAndStatusEntries,
  ...trascriptOverlayButtonsEntries,
  ...connectivityUIEntries,
  ...toastUIEntries,
  ...heroCardEntries,
  ...reasoningMessageEntries,
  ...greetingsMessageEntries,
  ...informativeMessageEntries,
  ...miscellaneousEntries,
  ...layoutEntries,
  ...customCSSEntries,
  ...customHandlers,
  ...generalEntries,
  ...launcherEntry,
  ...voiceEntries,
  searchEntry,
  themesEntry,
  localizationEntry,
];
